var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/ui/components/SampleChopperDialog.tsx
import { useCallback as useCallback12, useEffect as useEffect7, useRef as useRef8, useState as useState11 } from "react";
import * as Dialog from "@radix-ui/react-dialog";

// src/ui/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/ui/components/WaveformEditor.tsx
import { useRef, useEffect, useCallback, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SLICE_COLORS = [
  "rgba(59, 130, 246, 0.3)",
  // blue
  "rgba(34, 197, 94, 0.3)",
  // green
  "rgba(234, 179, 8, 0.3)",
  // yellow
  "rgba(168, 85, 247, 0.3)",
  // purple
  "rgba(236, 72, 153, 0.3)",
  // pink
  "rgba(20, 184, 166, 0.3)",
  // teal
  "rgba(249, 115, 22, 0.3)",
  // orange
  "rgba(99, 102, 241, 0.3)"
  // indigo
];
var SLICE_BORDER_COLORS = [
  "rgba(59, 130, 246, 0.8)",
  "rgba(34, 197, 94, 0.8)",
  "rgba(234, 179, 8, 0.8)",
  "rgba(168, 85, 247, 0.8)",
  "rgba(236, 72, 153, 0.8)",
  "rgba(20, 184, 166, 0.8)",
  "rgba(249, 115, 22, 0.8)",
  "rgba(99, 102, 241, 0.8)"
];
var HANDLE_WIDTH = 8;
var MIN_SLICE_SAMPLES = 100;
var MIN_ZOOM = 1;
var MAX_ZOOM = 64;
var ZOOM_STEP = 1.5;
function WaveformEditor({
  samples,
  sampleRate,
  sliceMarkers,
  selectedSlice,
  onSliceClick,
  height = 150,
  showTimeLabels = true,
  className,
  editable = false,
  onSliceChange,
  onSlicesChange,
  onSliceAdd,
  onSliceDelete,
  zoom: externalZoom,
  onZoomChange,
  showZoomControls = false,
  joinedEdges = false,
  playbackPosition
}) {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(600);
  const [dragState, setDragState] = useState(null);
  const [hoverState, setHoverState] = useState(null);
  const [internalZoom, setInternalZoom] = useState(1);
  const zoom = externalZoom != null ? externalZoom : internalZoom;
  const setZoom = onZoomChange != null ? onZoomChange : setInternalZoom;
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setCanvasWidth(entry.contentRect.width);
      }
    });
    resizeObserver.observe(container);
    setCanvasWidth(container.clientWidth);
    return () => resizeObserver.disconnect();
  }, []);
  const zoomedWidth = Math.round(canvasWidth * zoom);
  const pixelToSample = useCallback(
    (pixelX) => {
      if (!samples) return 0;
      const samplesPerPixel = samples.length / zoomedWidth;
      return Math.round(pixelX * samplesPerPixel);
    },
    [samples, zoomedWidth]
  );
  const sampleToPixel = useCallback(
    (samplePos) => {
      if (!samples) return 0;
      return samplePos / samples.length * zoomedWidth;
    },
    [samples, zoomedWidth]
  );
  const hitTest = useCallback(
    (pixelX) => {
      if (!samples) return null;
      for (let i = 0; i < sliceMarkers.length; i++) {
        const marker = sliceMarkers[i];
        const startX = sampleToPixel(marker.startSample);
        const endX = sampleToPixel(marker.endSample);
        if (editable) {
          if (Math.abs(pixelX - startX) <= HANDLE_WIDTH) {
            return { sliceIndex: i, edge: "start" };
          }
          if (Math.abs(pixelX - endX) <= HANDLE_WIDTH) {
            return { sliceIndex: i, edge: "end" };
          }
        }
        if (pixelX > startX + HANDLE_WIDTH && pixelX < endX - HANDLE_WIDTH) {
          return { sliceIndex: i, edge: "body" };
        }
      }
      return null;
    },
    [editable, samples, sliceMarkers, sampleToPixel]
  );
  const handleZoomIn = useCallback(() => {
    const newZoom = Math.min(MAX_ZOOM, zoom * ZOOM_STEP);
    setZoom(newZoom);
  }, [zoom, setZoom]);
  const handleZoomOut = useCallback(() => {
    const newZoom = Math.max(MIN_ZOOM, zoom / ZOOM_STEP);
    setZoom(newZoom);
  }, [zoom, setZoom]);
  const handleZoomReset = useCallback(() => {
    setZoom(1);
  }, [setZoom]);
  useEffect(() => {
    if (selectedSlice !== void 0 && scrollContainerRef.current && samples) {
      const marker = sliceMarkers[selectedSlice];
      if (marker) {
        const sliceCenter = (marker.startSample + marker.endSample) / 2;
        const pixelCenter = sampleToPixel(sliceCenter);
        const containerWidth = scrollContainerRef.current.clientWidth;
        const scrollTarget = pixelCenter - containerWidth / 2;
        const currentScroll = scrollContainerRef.current.scrollLeft;
        const sliceStart = sampleToPixel(marker.startSample);
        const sliceEnd = sampleToPixel(marker.endSample);
        if (sliceStart < currentScroll || sliceEnd > currentScroll + containerWidth) {
          scrollContainerRef.current.scrollTo({
            left: Math.max(0, scrollTarget),
            behavior: "smooth"
          });
        }
      }
    }
  }, [selectedSlice, sliceMarkers, samples, sampleToPixel]);
  useEffect(() => {
    var _a;
    const canvas = canvasRef.current;
    if (!canvas || !samples || samples.length === 0) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const width = canvas.width;
    const canvasHeight = canvas.height;
    const midY = canvasHeight / 2;
    ctx.fillStyle = "#1a1a2e";
    ctx.fillRect(0, 0, width, canvasHeight);
    ctx.strokeStyle = "#333";
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(0, midY);
    ctx.lineTo(width, midY);
    ctx.stroke();
    const samplesPerPixel = samples.length / width;
    const joinedBoundaries = /* @__PURE__ */ new Set();
    if (joinedEdges) {
      for (let i = 0; i < sliceMarkers.length - 1; i++) {
        const current = sliceMarkers[i];
        const next = sliceMarkers[i + 1];
        if (next && Math.abs(current.endSample - next.startSample) <= 10) {
          joinedBoundaries.add(i);
        }
      }
    }
    for (let i = 0; i < sliceMarkers.length; i++) {
      const marker = sliceMarkers[i];
      const x1 = Math.floor(marker.startSample / samplesPerPixel);
      const x2 = Math.ceil(marker.endSample / samplesPerPixel);
      const sliceWidth = x2 - x1;
      const isSelected = selectedSlice === i;
      const isHovered = (hoverState == null ? void 0 : hoverState.sliceIndex) === i;
      const colorIndex = i % SLICE_COLORS.length;
      const alpha = isSelected ? "0.5" : isHovered ? "0.4" : "0.3";
      ctx.fillStyle = SLICE_COLORS[colorIndex].replace("0.3", alpha);
      ctx.fillRect(x1, 0, sliceWidth, canvasHeight);
      ctx.strokeStyle = SLICE_BORDER_COLORS[colorIndex];
      ctx.lineWidth = isSelected ? 2 : 1;
      const startHovered = (hoverState == null ? void 0 : hoverState.sliceIndex) === i && (hoverState == null ? void 0 : hoverState.edge) === "start";
      const startIsJoined = i > 0 && joinedBoundaries.has(i - 1);
      ctx.lineWidth = startHovered || (dragState == null ? void 0 : dragState.sliceIndex) === i && (dragState == null ? void 0 : dragState.edge) === "start" ? 3 : isSelected ? 2 : 1;
      ctx.beginPath();
      ctx.moveTo(x1, 0);
      ctx.lineTo(x1, canvasHeight);
      ctx.stroke();
      const endHovered = (hoverState == null ? void 0 : hoverState.sliceIndex) === i && (hoverState == null ? void 0 : hoverState.edge) === "end";
      const endIsJoined = joinedBoundaries.has(i);
      ctx.lineWidth = endHovered || (dragState == null ? void 0 : dragState.sliceIndex) === i && (dragState == null ? void 0 : dragState.edge) === "end" ? 3 : isSelected ? 2 : 1;
      ctx.beginPath();
      ctx.moveTo(x2, 0);
      ctx.lineTo(x2, canvasHeight);
      ctx.stroke();
      if (editable) {
        const handleColor = SLICE_BORDER_COLORS[colorIndex];
        ctx.fillStyle = handleColor;
        if (startHovered || (dragState == null ? void 0 : dragState.sliceIndex) === i && (dragState == null ? void 0 : dragState.edge) === "start") {
          ctx.fillRect(x1 - 2, canvasHeight / 2 - 15, 4, 30);
          if (startIsJoined && joinedEdges) {
            ctx.fillStyle = "#fff";
            ctx.fillRect(x1 - 3, canvasHeight / 2 - 3, 6, 6);
            ctx.fillStyle = handleColor;
          }
        }
        if (endHovered || (dragState == null ? void 0 : dragState.sliceIndex) === i && (dragState == null ? void 0 : dragState.edge) === "end") {
          ctx.fillRect(x2 - 2, canvasHeight / 2 - 15, 4, 30);
          if (endIsJoined && joinedEdges) {
            ctx.fillStyle = "#fff";
            ctx.fillRect(x2 - 3, canvasHeight / 2 - 3, 6, 6);
            ctx.fillStyle = handleColor;
          }
        }
      }
      if (joinedEdges && endIsJoined) {
        ctx.fillStyle = "#f59e0b";
        const midY2 = canvasHeight / 2;
        ctx.beginPath();
        ctx.moveTo(x2, midY2 - 6);
        ctx.lineTo(x2 + 4, midY2);
        ctx.lineTo(x2, midY2 + 6);
        ctx.lineTo(x2 - 4, midY2);
        ctx.closePath();
        ctx.fill();
      }
    }
    ctx.strokeStyle = "#4ade80";
    ctx.lineWidth = 1;
    ctx.beginPath();
    for (let x = 0; x < width; x++) {
      const startSample = Math.floor(x * samplesPerPixel);
      const endSample = Math.min(Math.ceil((x + 1) * samplesPerPixel), samples.length);
      let min = 0;
      let max = 0;
      for (let i = startSample; i < endSample; i++) {
        const sample = samples[i];
        if (sample < min) min = sample;
        if (sample > max) max = sample;
      }
      const yMin = midY - max / 32768 * (midY - 10);
      const yMax = midY - min / 32768 * (midY - 10);
      if (x === 0) {
        ctx.moveTo(x, yMin);
      }
      ctx.lineTo(x, yMin);
      ctx.lineTo(x, yMax);
    }
    ctx.stroke();
    ctx.font = "10px system-ui, sans-serif";
    ctx.textBaseline = "top";
    for (let i = 0; i < sliceMarkers.length; i++) {
      const marker = sliceMarkers[i];
      const x = Math.floor(marker.startSample / samplesPerPixel) + 4;
      const label = (_a = marker.label) != null ? _a : `${i + 1}`;
      const colorIndex = i % SLICE_COLORS.length;
      ctx.fillStyle = SLICE_BORDER_COLORS[colorIndex];
      ctx.fillText(label, x, 4);
    }
    if (showTimeLabels) {
      const durationMs = samples.length / sampleRate * 1e3;
      const intervals = calculateTimeIntervals(durationMs, zoom);
      ctx.fillStyle = "#666";
      ctx.font = "9px system-ui, sans-serif";
      ctx.textBaseline = "bottom";
      for (const timeMs of intervals) {
        const x = timeMs / durationMs * width;
        const label = formatTimeLabel(timeMs);
        ctx.fillText(label, x + 2, canvasHeight - 2);
        ctx.strokeStyle = "#444";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(x, canvasHeight - 12);
        ctx.lineTo(x, canvasHeight);
        ctx.stroke();
      }
    }
    if (editable && !hoverState && !dragState) {
      ctx.fillStyle = "rgba(255, 255, 255, 0.1)";
      ctx.font = "11px system-ui, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
    }
    if (playbackPosition !== null && playbackPosition !== void 0) {
      const playheadX = Math.floor(playbackPosition / samplesPerPixel);
      ctx.strokeStyle = "#ef4444";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(playheadX, 0);
      ctx.lineTo(playheadX, canvasHeight);
      ctx.stroke();
      ctx.fillStyle = "#ef4444";
      ctx.beginPath();
      ctx.moveTo(playheadX - 6, 0);
      ctx.lineTo(playheadX + 6, 0);
      ctx.lineTo(playheadX, 8);
      ctx.closePath();
      ctx.fill();
    }
  }, [samples, sampleRate, sliceMarkers, selectedSlice, zoomedWidth, height, showTimeLabels, editable, hoverState, dragState, zoom, joinedEdges, playbackPosition]);
  const handleMouseMove = useCallback(
    (event) => {
      var _a, _b;
      const canvas = canvasRef.current;
      if (!canvas || !samples) return;
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      if (dragState && (onSliceChange || onSlicesChange)) {
        const newSample = pixelToSample(x);
        const marker = sliceMarkers[dragState.sliceIndex];
        if (!marker) return;
        let newMarker;
        let adjacentChange = null;
        if (dragState.edge === "start") {
          const prevSlice = dragState.sliceIndex > 0 ? sliceMarkers[dragState.sliceIndex - 1] : null;
          const minStart = joinedEdges && prevSlice ? prevSlice.startSample + MIN_SLICE_SAMPLES : (_a = prevSlice == null ? void 0 : prevSlice.endSample) != null ? _a : 0;
          const maxStart = marker.endSample - MIN_SLICE_SAMPLES;
          const constrainedStart = Math.max(minStart, Math.min(maxStart, newSample));
          newMarker = __spreadProps(__spreadValues({}, marker), { startSample: constrainedStart });
          if (joinedEdges && prevSlice) {
            adjacentChange = {
              index: dragState.sliceIndex - 1,
              marker: __spreadProps(__spreadValues({}, prevSlice), { endSample: constrainedStart })
            };
          }
        } else {
          const nextSlice = sliceMarkers[dragState.sliceIndex + 1];
          const maxEnd = joinedEdges && nextSlice ? nextSlice.endSample - MIN_SLICE_SAMPLES : (_b = nextSlice == null ? void 0 : nextSlice.startSample) != null ? _b : samples.length;
          const minEnd = marker.startSample + MIN_SLICE_SAMPLES;
          const constrainedEnd = Math.max(minEnd, Math.min(maxEnd, newSample));
          newMarker = __spreadProps(__spreadValues({}, marker), { endSample: constrainedEnd });
          if (joinedEdges && nextSlice) {
            adjacentChange = {
              index: dragState.sliceIndex + 1,
              marker: __spreadProps(__spreadValues({}, nextSlice), { startSample: constrainedEnd })
            };
          }
        }
        if (adjacentChange && onSlicesChange) {
          onSlicesChange([
            { index: dragState.sliceIndex, marker: newMarker },
            adjacentChange
          ]);
        } else if (onSliceChange) {
          onSliceChange(dragState.sliceIndex, newMarker);
        }
      } else {
        const hit = hitTest(x);
        setHoverState(hit);
      }
    },
    [samples, dragState, sliceMarkers, pixelToSample, hitTest, onSliceChange, onSlicesChange, joinedEdges]
  );
  const handleMouseDown = useCallback(
    (event) => {
      if (!editable || !samples) return;
      const canvas = canvasRef.current;
      if (!canvas) return;
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const hit = hitTest(x);
      if (hit && (hit.edge === "start" || hit.edge === "end")) {
        const marker = sliceMarkers[hit.sliceIndex];
        if (!marker) return;
        event.preventDefault();
        setDragState({
          sliceIndex: hit.sliceIndex,
          edge: hit.edge,
          startX: x,
          originalSample: hit.edge === "start" ? marker.startSample : marker.endSample
        });
      }
    },
    [editable, samples, sliceMarkers, hitTest]
  );
  const handleMouseUp = useCallback(() => {
    if (dragState) {
      setDragState(null);
    }
  }, [dragState]);
  const handleMouseLeave = useCallback(() => {
    setHoverState(null);
    if (dragState) {
      setDragState(null);
    }
  }, [dragState]);
  const handleClick = useCallback(
    (event) => {
      if (!samples) return;
      const canvas = canvasRef.current;
      if (!canvas) return;
      if (dragState) return;
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const clickedSample = pixelToSample(x);
      const hit = hitTest(x);
      if (hit) {
        if (onSliceClick && hit.edge === "body") {
          onSliceClick(hit.sliceIndex);
        }
      } else if (editable && onSliceAdd) {
        onSliceAdd(clickedSample);
      }
    },
    [samples, dragState, editable, pixelToSample, hitTest, onSliceClick, onSliceAdd]
  );
  const handleDoubleClick = useCallback(
    (event) => {
      if (!samples || !editable || !onSliceAdd) return;
      const canvas = canvasRef.current;
      if (!canvas) return;
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const clickedSample = pixelToSample(x);
      const hit = hitTest(x);
      if (hit && hit.edge === "body") {
        event.preventDefault();
        onSliceAdd(clickedSample);
      }
    },
    [samples, editable, pixelToSample, hitTest, onSliceAdd]
  );
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "+" || event.key === "=") {
        event.preventDefault();
        event.stopPropagation();
        handleZoomIn();
        return;
      }
      if (event.key === "-" || event.key === "_") {
        event.preventDefault();
        event.stopPropagation();
        handleZoomOut();
        return;
      }
      if (event.key === "0") {
        event.preventDefault();
        event.stopPropagation();
        handleZoomReset();
        return;
      }
      if (!editable || selectedSlice === void 0 || !onSliceDelete) return;
      if (event.key === "Delete" || event.key === "Backspace") {
        event.preventDefault();
        event.stopPropagation();
        onSliceDelete(selectedSlice);
      }
    },
    [editable, selectedSlice, onSliceDelete, handleZoomIn, handleZoomOut, handleZoomReset]
  );
  const getCursor = () => {
    if (dragState) return "ew-resize";
    if ((hoverState == null ? void 0 : hoverState.edge) === "start" || (hoverState == null ? void 0 : hoverState.edge) === "end") return "ew-resize";
    if ((hoverState == null ? void 0 : hoverState.edge) === "body") return "pointer";
    if (editable) return "crosshair";
    if (onSliceClick) return "pointer";
    return "default";
  };
  if (!samples || samples.length === 0) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "bg-ac-bg rounded border border-ac-accent/30 flex items-center justify-center",
          className
        ),
        style: { height },
        children: /* @__PURE__ */ jsx("span", { className: "text-ac-muted text-sm", children: "No audio loaded" })
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      className: cn("relative", className),
      onKeyDown: handleKeyDown,
      tabIndex: 0,
      children: [
        showZoomControls && /* @__PURE__ */ jsxs("div", { className: "absolute top-1 right-1 z-10 flex items-center gap-1 bg-ac-bg/80 rounded px-1", children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: handleZoomOut,
              disabled: zoom <= MIN_ZOOM,
              className: cn(
                "p-1 text-ac-muted hover:text-ac-text transition-colors",
                zoom <= MIN_ZOOM && "opacity-30 cursor-not-allowed"
              ),
              title: "Zoom out (-)",
              children: /* @__PURE__ */ jsx("svg", { className: "w-4 h-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M20 12H4" }) })
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: handleZoomReset,
              className: "px-1 text-xs text-ac-muted hover:text-ac-text transition-colors",
              title: "Reset zoom (0)",
              children: zoom > 1 ? `${zoom.toFixed(1)}\xD7` : "Fit"
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: handleZoomIn,
              disabled: zoom >= MAX_ZOOM,
              className: cn(
                "p-1 text-ac-muted hover:text-ac-text transition-colors",
                zoom >= MAX_ZOOM && "opacity-30 cursor-not-allowed"
              ),
              title: "Zoom in (+)",
              children: /* @__PURE__ */ jsx("svg", { className: "w-4 h-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) })
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            ref: scrollContainerRef,
            className: "overflow-x-auto",
            style: { height: height + 16 },
            children: /* @__PURE__ */ jsx(
              "canvas",
              {
                ref: canvasRef,
                width: zoomedWidth,
                height,
                onClick: handleClick,
                onDoubleClick: handleDoubleClick,
                onMouseMove: handleMouseMove,
                onMouseDown: handleMouseDown,
                onMouseUp: handleMouseUp,
                onMouseLeave: handleMouseLeave,
                className: cn("rounded border border-ac-accent/30 outline-none"),
                style: { cursor: getCursor() }
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "absolute bottom-5 right-2 text-xs text-ac-muted pointer-events-none", children: [
          (samples.length / sampleRate * 1e3).toFixed(0),
          "ms"
        ] }),
        editable && !dragState && sliceMarkers.length === 0 && /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex items-center justify-center pointer-events-none", children: /* @__PURE__ */ jsx("span", { className: "text-ac-muted text-sm bg-ac-bg/80 px-2 py-1 rounded", children: "Click to add slice points" }) }),
        zoom > 1 && /* @__PURE__ */ jsx("div", { className: "absolute bottom-5 left-2 text-xs text-ac-muted pointer-events-none", children: "Scroll to pan \u2022 +/- to zoom" })
      ]
    }
  );
}
function calculateTimeIntervals(durationMs, zoom) {
  const effectiveDuration = durationMs / zoom;
  let interval;
  if (effectiveDuration <= 100) {
    interval = 10;
  } else if (effectiveDuration <= 250) {
    interval = 25;
  } else if (effectiveDuration <= 500) {
    interval = 50;
  } else if (effectiveDuration <= 1e3) {
    interval = 100;
  } else if (effectiveDuration <= 2e3) {
    interval = 200;
  } else if (effectiveDuration <= 5e3) {
    interval = 500;
  } else {
    interval = 1e3;
  }
  const intervals = [];
  for (let t = interval; t < durationMs; t += interval) {
    intervals.push(t);
  }
  return intervals;
}
function formatTimeLabel(ms) {
  if (ms >= 1e3) {
    return `${(ms / 1e3).toFixed(1)}s`;
  }
  return `${ms}ms`;
}

// src/ui/components/SliceMethodPanel.tsx
import { useState as useState4, useCallback as useCallback4 } from "react";
import * as Tabs from "@radix-ui/react-tabs";

// src/ui/components/TriggerMethodContent.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function PlaybackControls({
  playbackConfig,
  onPolyphonyChange,
  onPlaybackModeChange,
  onMuteGroupChange,
  slices,
  latencyMs
}) {
  return /* @__PURE__ */ jsxs2("div", { className: "space-y-3 border-t border-ac-accent/30 pt-3", children: [
    /* @__PURE__ */ jsxs2("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsx2("div", { className: "text-xs text-ac-muted uppercase tracking-wide", children: "Playback" }),
      latencyMs !== null && /* @__PURE__ */ jsxs2("div", { className: "text-xs text-ac-muted", title: "Audio output latency (baseLatency + outputLatency)", children: [
        latencyMs,
        "ms latency"
      ] })
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx2("div", { className: "text-xs text-ac-muted", children: "Voices" }),
        /* @__PURE__ */ jsx2("div", { className: "flex rounded overflow-hidden border border-ac-accent/50", children: ["mono", "poly"].map((mode) => /* @__PURE__ */ jsx2(
          "button",
          {
            onClick: () => onPolyphonyChange(mode),
            className: cn(
              "px-3 py-1 text-xs transition-colors",
              playbackConfig.polyphony === mode ? "bg-ac-highlight text-white" : "bg-ac-bg text-ac-muted hover:text-ac-text"
            ),
            children: mode === "mono" ? "Mono" : "Poly"
          },
          mode
        )) })
      ] }),
      /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx2("div", { className: "text-xs text-ac-muted", children: "Mode" }),
        /* @__PURE__ */ jsx2("div", { className: "flex rounded overflow-hidden border border-ac-accent/50", children: ["one-shot", "gate"].map((mode) => /* @__PURE__ */ jsx2(
          "button",
          {
            onClick: () => onPlaybackModeChange(mode),
            className: cn(
              "px-3 py-1 text-xs transition-colors",
              playbackConfig.playbackMode === mode ? "bg-ac-highlight text-white" : "bg-ac-bg text-ac-muted hover:text-ac-text"
            ),
            children: mode === "one-shot" ? "One-Shot" : "Gate"
          },
          mode
        )) })
      ] })
    ] }),
    playbackConfig.polyphony === "poly" && slices.length > 1 && /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsxs2("div", { className: "text-xs text-ac-muted", children: [
        "Mute Groups",
        /* @__PURE__ */ jsx2("span", { className: "ml-1 text-ac-muted/60", children: "(slices in the same group choke each other)" })
      ] }),
      /* @__PURE__ */ jsx2("div", { className: "flex flex-wrap gap-1.5", children: slices.map((slice, i) => {
        var _a;
        const group = (_a = playbackConfig.muteGroups[i]) != null ? _a : 0;
        return /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-1 bg-ac-bg rounded px-2 py-0.5", children: [
          /* @__PURE__ */ jsx2("span", { className: "text-xs text-ac-text truncate max-w-[4rem]", title: slice.label, children: slice.label }),
          /* @__PURE__ */ jsxs2(
            "select",
            {
              value: group,
              onChange: (e) => onMuteGroupChange(i, parseInt(e.target.value)),
              className: "bg-transparent text-xs text-ac-muted border-none outline-none cursor-pointer py-0",
              title: `Mute group for ${slice.label}`,
              children: [
                /* @__PURE__ */ jsx2("option", { value: 0, children: "\u2014" }),
                [1, 2, 3, 4, 5, 6, 7, 8].map((g) => /* @__PURE__ */ jsxs2("option", { value: g, children: [
                  "G",
                  g
                ] }, g))
              ]
            }
          )
        ] }, i);
      }) })
    ] })
  ] });
}
function TriggerMethodContent({
  state,
  midiAvailable,
  triggerCount,
  onArm,
  onStop,
  onReset,
  playbackConfig,
  onPolyphonyChange,
  onPlaybackModeChange,
  onMuteGroupChange,
  slices,
  latencyMs
}) {
  if (state === "recording") {
    return /* @__PURE__ */ jsxs2("div", { className: "space-y-3", children: [
      /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsxs2("span", { className: "relative flex h-3 w-3", children: [
          /* @__PURE__ */ jsx2("span", { className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" }),
          /* @__PURE__ */ jsx2("span", { className: "relative inline-flex rounded-full h-3 w-3 bg-red-500" })
        ] }),
        /* @__PURE__ */ jsx2("span", { className: "text-sm text-ac-text font-medium", children: "Recording triggers..." })
      ] }),
      /* @__PURE__ */ jsxs2("div", { className: "text-xs text-ac-muted", children: [
        "Press any key or MIDI pad to mark slice points. ",
        triggerCount,
        " trigger",
        triggerCount !== 1 ? "s" : "",
        " captured."
      ] }),
      /* @__PURE__ */ jsx2(
        "button",
        {
          onClick: onStop,
          className: "px-3 py-1.5 text-xs rounded bg-red-600 hover:bg-red-500 text-white font-medium transition-colors",
          children: "Stop Recording"
        }
      )
    ] });
  }
  if (state === "armed") {
    return /* @__PURE__ */ jsxs2("div", { className: "space-y-3", children: [
      /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsxs2("span", { className: "relative flex h-3 w-3", children: [
          /* @__PURE__ */ jsx2("span", { className: "animate-pulse absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75" }),
          /* @__PURE__ */ jsx2("span", { className: "relative inline-flex rounded-full h-3 w-3 bg-yellow-500" })
        ] }),
        /* @__PURE__ */ jsx2("span", { className: "text-sm text-ac-text font-medium", children: "Armed \u2014 press any key to start" })
      ] }),
      /* @__PURE__ */ jsx2("p", { className: "text-xs text-ac-muted", children: "Press any key or MIDI pad to begin playback and mark your first slice point." }),
      /* @__PURE__ */ jsx2(
        "button",
        {
          onClick: onReset,
          className: "px-3 py-1.5 text-xs rounded bg-ac-bg hover:bg-ac-accent/50 text-ac-muted transition-colors",
          children: "Cancel"
        }
      )
    ] });
  }
  if (state === "complete") {
    return /* @__PURE__ */ jsxs2("div", { className: "space-y-3", children: [
      /* @__PURE__ */ jsxs2("p", { className: "text-sm text-ac-text", children: [
        triggerCount,
        " trigger",
        triggerCount !== 1 ? "s" : "",
        " captured \u2014 ",
        triggerCount,
        " slice",
        triggerCount !== 1 ? "s" : "",
        " created. Press mapped keys to play slices."
      ] }),
      /* @__PURE__ */ jsx2("div", { className: "flex gap-2", children: /* @__PURE__ */ jsx2(
        "button",
        {
          onClick: onReset,
          className: "px-3 py-1.5 text-xs rounded bg-ac-bg hover:bg-ac-accent/50 text-ac-muted transition-colors",
          children: "Record Again"
        }
      ) }),
      /* @__PURE__ */ jsx2(
        PlaybackControls,
        {
          playbackConfig,
          onPolyphonyChange,
          onPlaybackModeChange,
          onMuteGroupChange,
          slices,
          latencyMs
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs2("div", { className: "space-y-3", children: [
    /* @__PURE__ */ jsx2("p", { className: "text-xs text-ac-muted", children: "Arm to play back audio and mark slice points in real time by pressing any key or MIDI pad. Each keypress marks a slice boundary at the current playback position." }),
    /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx2(
        "button",
        {
          onClick: onArm,
          className: "px-3 py-1.5 text-xs rounded bg-ac-highlight hover:bg-ac-highlight/80 text-white font-medium transition-colors",
          children: "Arm"
        }
      ),
      /* @__PURE__ */ jsxs2(
        "span",
        {
          className: cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs",
            midiAvailable ? "bg-green-900/30 text-green-400" : "bg-ac-bg text-ac-muted"
          ),
          children: [
            /* @__PURE__ */ jsx2("span", { className: cn(
              "inline-block w-1.5 h-1.5 rounded-full",
              midiAvailable ? "bg-green-400" : "bg-ac-muted"
            ) }),
            midiAvailable ? "MIDI connected" : "No MIDI (keyboard only)"
          ]
        }
      )
    ] })
  ] });
}

// src/ui/hooks/useMidiLearn.ts
import { useState as useState3, useCallback as useCallback3, useEffect as useEffect3, useRef as useRef3 } from "react";

// src/ui/hooks/useTriggerInput.ts
import { useState as useState2, useCallback as useCallback2, useEffect as useEffect2, useRef as useRef2 } from "react";
function keyTriggerId(key) {
  return `key:${key.toLowerCase()}`;
}
function midiTriggerId(note) {
  return `midi:${note}`;
}
var IGNORED_KEYS = /* @__PURE__ */ new Set([
  "Shift",
  "Control",
  "Alt",
  "Meta",
  "CapsLock",
  "Tab",
  "Escape",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12"
]);
function useTriggerInput({
  playbackPositionRef,
  isPlaying,
  onPlay,
  onStop,
  onTrigger,
  preventAutoComplete
}) {
  const [state, setState] = useState2("idle");
  const [midiAvailable, setMidiAvailable] = useState2(false);
  const stateRef = useRef2("idle");
  const midiAccessRef = useRef2(null);
  const onPlayRef = useRef2(onPlay);
  const onTriggerRef = useRef2(onTrigger);
  stateRef.current = state;
  onPlayRef.current = onPlay;
  onTriggerRef.current = onTrigger;
  useEffect2(() => {
    if (!navigator.requestMIDIAccess) return;
    navigator.requestMIDIAccess().then(
      (access) => {
        midiAccessRef.current = access;
        setMidiAvailable(true);
      },
      () => setMidiAvailable(false)
    );
  }, []);
  const wasPlayingRef = useRef2(false);
  useEffect2(() => {
    if (wasPlayingRef.current && !isPlaying && stateRef.current === "recording") {
      if (!(preventAutoComplete == null ? void 0 : preventAutoComplete.current)) {
        setState("complete");
      }
    }
    wasPlayingRef.current = isPlaying;
  }, [isPlaying, preventAutoComplete]);
  const fireTrigger = useCallback2((id) => {
    if (stateRef.current === "armed") {
      stateRef.current = "recording";
      setState("recording");
      onPlayRef.current();
      onTriggerRef.current(0, id);
      return;
    }
    if (stateRef.current === "recording") {
      const pos = playbackPositionRef.current;
      onTriggerRef.current(pos != null ? pos : -1, id);
    }
  }, [playbackPositionRef]);
  useEffect2(() => {
    const handleKeyDown = (event) => {
      if (stateRef.current !== "armed" && stateRef.current !== "recording") return;
      if (event.repeat) return;
      if (IGNORED_KEYS.has(event.key)) return;
      const target = event.target;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT") return;
      event.preventDefault();
      event.stopPropagation();
      fireTrigger(keyTriggerId(event.key));
    };
    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [fireTrigger]);
  useEffect2(() => {
    if (!midiAccessRef.current) return;
    const handleMidiMessage = (event) => {
      if (stateRef.current !== "armed" && stateRef.current !== "recording") return;
      const data = event.data;
      if (!data || data.length < 3) return;
      const status = data[0] & 240;
      const velocity = data[2];
      if (status === 144 && velocity > 0) {
        fireTrigger(midiTriggerId(data[1]));
      }
    };
    const inputs = midiAccessRef.current.inputs;
    inputs.forEach((input) => {
      input.addEventListener("midimessage", handleMidiMessage);
    });
    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("midimessage", handleMidiMessage);
      });
    };
  }, [fireTrigger, midiAvailable]);
  const arm = useCallback2(() => {
    if (stateRef.current === "idle" || stateRef.current === "complete") {
      setState("armed");
    }
  }, []);
  const stopRecording = useCallback2(() => {
    if (stateRef.current === "recording") {
      onStop();
      setState("complete");
    }
  }, [onStop]);
  const reset = useCallback2(() => {
    if (isPlaying) onStop();
    setState("idle");
  }, [isPlaying, onStop]);
  return { state, midiAvailable, arm, stopRecording, reset };
}

// src/ui/hooks/useMidiLearn.ts
var NOTE_NAMES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
function midiNoteToName(note) {
  return `${NOTE_NAMES[note % 12]}${Math.floor(note / 12) - 1}`;
}
function triggerDisplayName(triggerId) {
  if (triggerId.startsWith("midi:")) {
    return midiNoteToName(parseInt(triggerId.slice(5)));
  }
  if (triggerId.startsWith("key:")) {
    return triggerId.slice(4).toUpperCase();
  }
  return triggerId;
}
var IGNORED_KEYS2 = /* @__PURE__ */ new Set([
  "Shift",
  "Control",
  "Alt",
  "Meta",
  "CapsLock",
  "Tab",
  "Escape",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12",
  " ",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Delete",
  "Backspace"
]);
function useMidiLearn({
  enabled,
  onLearn
}) {
  const [learningSliceIndex, setLearningSliceIndex] = useState3(null);
  const onLearnRef = useRef3(onLearn);
  onLearnRef.current = onLearn;
  const startLearning = useCallback3((sliceIndex) => {
    setLearningSliceIndex(sliceIndex);
  }, []);
  const cancelLearning = useCallback3(() => {
    setLearningSliceIndex(null);
  }, []);
  useEffect3(() => {
    if (!enabled) setLearningSliceIndex(null);
  }, [enabled]);
  useEffect3(() => {
    if (learningSliceIndex === null) return;
    const handleKeyDown = (event) => {
      if (event.repeat) return;
      if (IGNORED_KEYS2.has(event.key)) return;
      const target = event.target;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT") return;
      event.preventDefault();
      event.stopPropagation();
      onLearnRef.current(learningSliceIndex, keyTriggerId(event.key));
      setLearningSliceIndex(null);
    };
    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [learningSliceIndex]);
  useEffect3(() => {
    if (learningSliceIndex === null || !navigator.requestMIDIAccess) return;
    let inputs = null;
    const handleMidiMessage = (event) => {
      const data = event.data;
      if (!data || data.length < 3) return;
      const status = data[0] & 240;
      const velocity = data[2];
      if (status === 144 && velocity > 0) {
        onLearnRef.current(learningSliceIndex, midiTriggerId(data[1]));
        setLearningSliceIndex(null);
      }
    };
    navigator.requestMIDIAccess().then(
      (access) => {
        inputs = access.inputs;
        inputs.forEach((input) => {
          input.addEventListener("midimessage", handleMidiMessage);
        });
      },
      () => {
      }
    );
    return () => {
      if (inputs) {
        inputs.forEach((input) => {
          input.removeEventListener("midimessage", handleMidiMessage);
        });
      }
    };
  }, [learningSliceIndex]);
  return {
    learningSliceIndex,
    isLearning: learningSliceIndex !== null,
    startLearning,
    cancelLearning
  };
}

// src/ui/components/SliceMethodPanel.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var WHITE_KEY_OFFSETS = [0, 2, 4, 5, 7, 9, 11];
var BLACK_KEY_OFFSETS = [1, 3, 6, 8, 10];
function generateMidiNotes(startNote, count, pattern) {
  const notes = [];
  if (pattern === "chromatic") {
    for (let i = 0; i < count && startNote + i <= 127; i++) {
      notes.push(startNote + i);
    }
  } else {
    const offsets = pattern === "white-keys" ? WHITE_KEY_OFFSETS : BLACK_KEY_OFFSETS;
    const startOctaveBase = Math.floor(startNote / 12) * 12;
    const startPc = startNote % 12;
    let offsetIdx = offsets.findIndex((o) => o >= startPc);
    if (offsetIdx === -1) {
      offsetIdx = 0;
    }
    let octaveBase = startOctaveBase;
    if (offsets[offsetIdx] < startPc) {
      octaveBase += 12;
      offsetIdx = 0;
    }
    while (notes.length < count) {
      const note = octaveBase + offsets[offsetIdx];
      if (note > 127) break;
      if (note >= startNote) notes.push(note);
      offsetIdx++;
      if (offsetIdx >= offsets.length) {
        offsetIdx = 0;
        octaveBase += 12;
      }
    }
  }
  return notes;
}
function AutoMapPanel({
  sliceCount,
  startNote,
  onStartNoteChange,
  pattern,
  onPatternChange,
  onApply,
  onCancel
}) {
  const notes = generateMidiNotes(startNote, sliceCount, pattern);
  const allMapped = notes.length >= sliceCount;
  const handleApply = useCallback4(() => {
    const mappings = notes.map((note, i) => ({
      sliceIndex: i,
      triggerId: midiTriggerId(note)
    }));
    onApply(mappings);
  }, [notes, onApply]);
  return /* @__PURE__ */ jsxs3("div", { className: "border border-ac-accent/30 rounded p-3 space-y-3", children: [
    /* @__PURE__ */ jsx3("p", { className: "text-xs text-ac-muted", children: "Assign MIDI notes to slices automatically." }),
    /* @__PURE__ */ jsxs3("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ jsxs3("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx3("label", { className: "block text-xs text-ac-muted", children: "Start Note" }),
        /* @__PURE__ */ jsxs3("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ jsx3(
            "input",
            {
              type: "number",
              min: 0,
              max: 127,
              value: startNote,
              onChange: (e) => onStartNoteChange(Math.max(0, Math.min(127, parseInt(e.target.value) || 0))),
              className: "w-16 bg-ac-bg border border-ac-accent/50 rounded px-2 py-1 text-sm text-ac-text"
            }
          ),
          /* @__PURE__ */ jsx3("span", { className: "text-xs text-ac-muted font-mono", children: midiNoteToName(startNote) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs3("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx3("label", { className: "block text-xs text-ac-muted", children: "Pattern" }),
        /* @__PURE__ */ jsx3("div", { className: "flex rounded overflow-hidden border border-ac-accent/50", children: [
          ["chromatic", "Chromatic"],
          ["white-keys", "White Keys"],
          ["black-keys", "Black Keys"]
        ].map(([value, label]) => /* @__PURE__ */ jsx3(
          "button",
          {
            onClick: () => onPatternChange(value),
            className: cn(
              "px-2.5 py-1 text-xs transition-colors",
              pattern === value ? "bg-ac-highlight text-white" : "bg-ac-bg text-ac-muted hover:text-ac-text"
            ),
            children: label
          },
          value
        )) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs3("div", { className: "text-xs text-ac-muted bg-ac-bg rounded p-2", children: [
      /* @__PURE__ */ jsx3("div", { className: "flex flex-wrap gap-1", children: notes.map((note, i) => /* @__PURE__ */ jsx3("span", { className: "font-mono text-[10px] bg-ac-accent/30 text-ac-text px-1.5 py-0.5 rounded", children: midiNoteToName(note) }, i)) }),
      !allMapped && /* @__PURE__ */ jsxs3("p", { className: "mt-1 text-red-400", children: [
        "Not enough notes in range for ",
        sliceCount,
        " slices (only ",
        notes.length,
        " available)"
      ] })
    ] }),
    /* @__PURE__ */ jsxs3("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsx3(
        "button",
        {
          onClick: onCancel,
          className: "flex-1 px-3 py-1.5 text-xs rounded bg-ac-bg hover:bg-ac-accent/50 text-ac-muted transition-colors",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ jsxs3(
        "button",
        {
          onClick: handleApply,
          disabled: notes.length === 0,
          className: cn(
            "flex-1 px-3 py-1.5 text-xs rounded bg-ac-highlight hover:bg-ac-highlight/80 text-white font-medium transition-colors",
            notes.length === 0 && "opacity-50 cursor-not-allowed"
          ),
          children: [
            "Apply (",
            notes.length,
            " mapping",
            notes.length !== 1 ? "s" : "",
            ")"
          ]
        }
      )
    ] })
  ] });
}
function SliceMethodPanel({
  selectedMethod,
  onMethodChange,
  transientThreshold,
  onTransientThresholdChange,
  transientMinGap,
  onTransientMinGapChange,
  transientPrePad,
  onTransientPrePadChange,
  fixedCount,
  onFixedCountChange,
  stripSilenceThreshold,
  onStripSilenceThresholdChange,
  stripSilenceActive,
  strippedPreview,
  originalSliceBoundaries,
  onApplyStripSilence,
  onCancelStripSilence,
  onActivateStripSilence,
  manualSlices,
  triggerProps,
  onAutoMap,
  onApplyAutoSlice,
  autoSliceCount
}) {
  const [activeTool, setActiveTool] = useState4(null);
  const [autoMapStartNote, setAutoMapStartNote] = useState4(36);
  const [autoMapPattern, setAutoMapPattern] = useState4("chromatic");
  const toggleTool = useCallback4((tool) => {
    const closing = activeTool === tool;
    if (activeTool === "strip-silence") {
      onCancelStripSilence();
    }
    if (closing) {
      setActiveTool(null);
    } else {
      setActiveTool(tool);
      if (tool === "strip-silence") {
        onActivateStripSilence();
      }
    }
  }, [activeTool, onCancelStripSilence, onActivateStripSilence]);
  const handleMethodChange = useCallback4((method) => {
    if (activeTool === "strip-silence") {
      onCancelStripSilence();
    }
    setActiveTool(null);
    onMethodChange(method);
  }, [activeTool, onCancelStripSilence, onMethodChange]);
  return /* @__PURE__ */ jsxs3(
    Tabs.Root,
    {
      value: selectedMethod,
      onValueChange: (v) => handleMethodChange(v),
      children: [
        /* @__PURE__ */ jsx3(Tabs.List, { className: "flex border-b border-ac-accent/30 mb-4", children: ["manual", "transient", "fixed"].map((method) => /* @__PURE__ */ jsx3(
          Tabs.Trigger,
          {
            value: method,
            className: cn(
              "px-4 py-2 text-sm border-b-2 -mb-px transition-colors",
              selectedMethod === method ? "border-ac-highlight text-ac-text" : "border-transparent text-ac-muted hover:text-ac-text"
            ),
            children: method.charAt(0).toUpperCase() + method.slice(1)
          },
          method
        )) }),
        /* @__PURE__ */ jsxs3(Tabs.Content, { value: "manual", className: "space-y-3", children: [
          /* @__PURE__ */ jsx3("p", { className: "text-xs text-ac-muted", children: "Double-click on a slice to split it. Drag slice edges to adjust boundaries. Use +/- to zoom for fine adjustments." }),
          /* @__PURE__ */ jsxs3("div", { className: "flex gap-2", children: [
            triggerProps && /* @__PURE__ */ jsx3(
              "button",
              {
                onClick: () => toggleTool("record"),
                className: cn(
                  "px-3 py-1.5 text-xs rounded font-medium transition-colors",
                  activeTool === "record" ? "bg-ac-highlight/20 text-ac-highlight border border-ac-highlight/30" : "bg-ac-bg text-ac-muted hover:text-ac-text border border-transparent"
                ),
                children: "Record Triggers"
              }
            ),
            /* @__PURE__ */ jsx3(
              "button",
              {
                onClick: () => toggleTool("strip-silence"),
                disabled: manualSlices.length === 0,
                className: cn(
                  "px-3 py-1.5 text-xs rounded font-medium transition-colors",
                  activeTool === "strip-silence" ? "bg-ac-highlight/20 text-ac-highlight border border-ac-highlight/30" : "bg-ac-bg text-ac-muted hover:text-ac-text border border-transparent",
                  manualSlices.length === 0 && "opacity-30 cursor-not-allowed"
                ),
                children: "Strip Silence"
              }
            ),
            onAutoMap && /* @__PURE__ */ jsx3(
              "button",
              {
                onClick: () => toggleTool("auto-map"),
                disabled: manualSlices.length === 0,
                className: cn(
                  "px-3 py-1.5 text-xs rounded font-medium transition-colors",
                  activeTool === "auto-map" ? "bg-ac-highlight/20 text-ac-highlight border border-ac-highlight/30" : "bg-ac-bg text-ac-muted hover:text-ac-text border border-transparent",
                  manualSlices.length === 0 && "opacity-30 cursor-not-allowed"
                ),
                children: "Auto-Map"
              }
            )
          ] }),
          activeTool === "record" && triggerProps && /* @__PURE__ */ jsx3("div", { className: "border border-ac-accent/30 rounded p-3", children: /* @__PURE__ */ jsx3(TriggerMethodContent, __spreadValues({}, triggerProps)) }),
          activeTool === "strip-silence" && manualSlices.length > 0 && /* @__PURE__ */ jsxs3("div", { className: "border border-ac-accent/30 rounded p-3 space-y-3", children: [
            /* @__PURE__ */ jsx3("p", { className: "text-xs text-ac-muted", children: "Remove silence from the beginning and end of each slice. Adjust threshold to preview changes live on the waveform." }),
            /* @__PURE__ */ jsxs3("div", { children: [
              /* @__PURE__ */ jsxs3("label", { className: "block text-xs text-ac-muted mb-1", children: [
                "Threshold: ",
                stripSilenceThreshold,
                " dB"
              ] }),
              /* @__PURE__ */ jsx3(
                "input",
                {
                  type: "range",
                  min: "-60",
                  max: "-10",
                  step: "1",
                  value: stripSilenceThreshold,
                  onChange: (e) => onStripSilenceThresholdChange(parseInt(e.target.value)),
                  className: "w-full accent-ac-highlight"
                }
              ),
              /* @__PURE__ */ jsxs3("div", { className: "flex justify-between text-xs text-ac-muted mt-0.5", children: [
                /* @__PURE__ */ jsx3("span", { children: "-60 dB (quieter)" }),
                /* @__PURE__ */ jsx3("span", { children: "-10 dB (louder)" })
              ] })
            ] }),
            strippedPreview && /* @__PURE__ */ jsxs3("div", { className: "text-xs text-ac-muted bg-ac-bg rounded p-2", children: [
              /* @__PURE__ */ jsx3("span", { className: "font-medium text-ac-text", children: strippedPreview.filter(
                (p, i) => {
                  var _a, _b;
                  return p.startSample !== ((_a = originalSliceBoundaries[i]) == null ? void 0 : _a.startSample) || p.endSample !== ((_b = originalSliceBoundaries[i]) == null ? void 0 : _b.endSample);
                }
              ).length }),
              " ",
              "of ",
              manualSlices.length,
              " slices will be trimmed"
            ] }),
            /* @__PURE__ */ jsxs3("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ jsx3(
                "button",
                {
                  onClick: () => {
                    onCancelStripSilence();
                    setActiveTool(null);
                  },
                  className: "flex-1 px-3 py-1.5 text-xs rounded bg-ac-bg hover:bg-ac-accent/50 text-ac-muted transition-colors",
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ jsx3(
                "button",
                {
                  onClick: () => {
                    onApplyStripSilence();
                    setActiveTool(null);
                  },
                  className: "flex-1 px-3 py-1.5 text-xs rounded bg-ac-highlight hover:bg-ac-highlight/80 text-white font-medium transition-colors",
                  children: "Apply Strip"
                }
              )
            ] })
          ] }),
          activeTool === "auto-map" && onAutoMap && manualSlices.length > 0 && /* @__PURE__ */ jsx3(
            AutoMapPanel,
            {
              sliceCount: manualSlices.length,
              startNote: autoMapStartNote,
              onStartNoteChange: setAutoMapStartNote,
              pattern: autoMapPattern,
              onPatternChange: setAutoMapPattern,
              onApply: (mappings) => {
                onAutoMap(mappings);
                setActiveTool(null);
              },
              onCancel: () => setActiveTool(null)
            }
          )
        ] }),
        /* @__PURE__ */ jsxs3(Tabs.Content, { value: "transient", className: "space-y-3", children: [
          /* @__PURE__ */ jsx3("p", { className: "text-xs text-ac-muted", children: "Detect drum hits by amplitude spikes above a threshold." }),
          /* @__PURE__ */ jsxs3("div", { className: "grid grid-cols-3 gap-4", children: [
            /* @__PURE__ */ jsxs3("div", { children: [
              /* @__PURE__ */ jsxs3("label", { className: "block text-xs text-ac-muted mb-1", children: [
                "Threshold (",
                (transientThreshold * 100).toFixed(0),
                "%)"
              ] }),
              /* @__PURE__ */ jsx3(
                "input",
                {
                  type: "range",
                  min: "0.05",
                  max: "0.9",
                  step: "0.05",
                  value: transientThreshold,
                  onChange: (e) => onTransientThresholdChange(parseFloat(e.target.value)),
                  className: "w-full accent-ac-highlight"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs3("div", { children: [
              /* @__PURE__ */ jsx3("label", { className: "block text-xs text-ac-muted mb-1", children: "Min Gap (ms)" }),
              /* @__PURE__ */ jsx3(
                "input",
                {
                  type: "number",
                  min: "10",
                  max: "1000",
                  step: "10",
                  value: transientMinGap,
                  onChange: (e) => onTransientMinGapChange(parseInt(e.target.value) || 100),
                  className: "w-full bg-ac-bg border border-ac-accent/50 rounded px-2 py-1 text-sm text-ac-text"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs3("div", { children: [
              /* @__PURE__ */ jsx3("label", { className: "block text-xs text-ac-muted mb-1", children: "Pre-pad (ms)" }),
              /* @__PURE__ */ jsx3(
                "input",
                {
                  type: "number",
                  min: "0",
                  max: "100",
                  step: "5",
                  value: transientPrePad,
                  onChange: (e) => onTransientPrePadChange(parseInt(e.target.value) || 0),
                  className: "w-full bg-ac-bg border border-ac-accent/50 rounded px-2 py-1 text-sm text-ac-text"
                }
              )
            ] })
          ] }),
          onApplyAutoSlice && /* @__PURE__ */ jsxs3(
            "button",
            {
              onClick: onApplyAutoSlice,
              disabled: !autoSliceCount,
              className: cn(
                "w-full px-3 py-2 text-sm rounded border font-medium transition-colors",
                autoSliceCount ? "bg-ac-highlight/20 text-ac-highlight border-ac-highlight/30 hover:bg-ac-highlight/30 cursor-pointer" : "bg-ac-bg text-ac-muted border-ac-accent/30 opacity-50 cursor-not-allowed"
              ),
              children: [
                "Apply ",
                autoSliceCount ? `${autoSliceCount} slice${autoSliceCount !== 1 ? "s" : ""}` : "detection"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxs3(Tabs.Content, { value: "fixed", className: "space-y-3", children: [
          /* @__PURE__ */ jsx3("p", { className: "text-xs text-ac-muted", children: "Split into a fixed number of equal-length slices." }),
          /* @__PURE__ */ jsxs3("div", { children: [
            /* @__PURE__ */ jsx3("label", { className: "block text-xs text-ac-muted mb-1", children: "Number of slices" }),
            /* @__PURE__ */ jsx3(
              "input",
              {
                type: "number",
                min: "1",
                max: "32",
                step: "1",
                value: fixedCount,
                onChange: (e) => onFixedCountChange(Math.max(1, parseInt(e.target.value) || 1)),
                className: "w-full bg-ac-bg border border-ac-accent/50 rounded px-2 py-1 text-sm text-ac-text"
              }
            )
          ] }),
          onApplyAutoSlice && /* @__PURE__ */ jsxs3(
            "button",
            {
              onClick: onApplyAutoSlice,
              disabled: !autoSliceCount,
              className: cn(
                "w-full px-3 py-2 text-sm rounded border font-medium transition-colors",
                autoSliceCount ? "bg-ac-highlight/20 text-ac-highlight border-ac-highlight/30 hover:bg-ac-highlight/30 cursor-pointer" : "bg-ac-bg text-ac-muted border-ac-accent/30 opacity-50 cursor-not-allowed"
              ),
              children: [
                "Apply ",
                autoSliceCount ? `${autoSliceCount} slice${autoSliceCount !== 1 ? "s" : ""}` : "detection"
              ]
            }
          )
        ] })
      ]
    }
  );
}

// src/ui/components/SliceList.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
function TriggerControls({
  sliceIndex,
  triggerAssignments,
  learningSliceIndex,
  onStartLearn,
  onCancelLearn,
  onClearTrigger
}) {
  const assignment = triggerAssignments.find((t) => t.sliceIndex === sliceIndex);
  const isLearning = learningSliceIndex === sliceIndex;
  return /* @__PURE__ */ jsxs4("div", { className: "flex items-center gap-1", onClick: (e) => e.stopPropagation(), children: [
    assignment && /* @__PURE__ */ jsx4("span", { className: "font-mono text-[10px] bg-ac-accent/30 text-ac-text px-1.5 py-0.5 rounded", children: triggerDisplayName(assignment.triggerId) }),
    /* @__PURE__ */ jsx4(
      "button",
      {
        onClick: () => isLearning ? onCancelLearn == null ? void 0 : onCancelLearn() : onStartLearn(sliceIndex),
        className: cn(
          "px-1.5 py-0.5 rounded text-[10px] font-medium transition-colors",
          isLearning ? "bg-yellow-500/30 text-yellow-300 animate-pulse" : "bg-ac-bg text-ac-muted hover:text-ac-text"
        ),
        title: isLearning ? "Cancel learn" : "Learn trigger: press a MIDI pad or key",
        children: isLearning ? "..." : "Learn"
      }
    ),
    assignment && onClearTrigger && /* @__PURE__ */ jsx4(
      "button",
      {
        onClick: () => onClearTrigger(sliceIndex),
        className: "text-red-400 hover:text-red-300 text-[10px] px-0.5",
        title: "Clear trigger assignment",
        children: "\xD7"
      }
    )
  ] });
}
function SliceList({
  slices,
  selectedSlice,
  sampleRate,
  isPlaying,
  onSliceSelect,
  onSlicePlay,
  onSliceDelete,
  editable = false,
  triggerAssignments,
  learningSliceIndex,
  onStartLearn,
  onCancelLearn,
  onClearTrigger
}) {
  if (slices.length === 0) {
    if (editable) {
      return /* @__PURE__ */ jsx4("div", { className: "text-sm text-ac-muted text-center py-4", children: "Click on the waveform to add slice points" });
    }
    return /* @__PURE__ */ jsx4("div", { className: "text-sm text-ac-muted text-center py-4", children: "No slices detected" });
  }
  return /* @__PURE__ */ jsxs4("div", { className: "bg-ac-bg rounded p-3 space-y-2 max-h-32 overflow-y-auto", children: [
    /* @__PURE__ */ jsxs4("div", { className: "text-xs text-ac-muted uppercase tracking-wide mb-2", children: [
      "Slices (",
      slices.length,
      ")"
    ] }),
    slices.map((slice, i) => /* @__PURE__ */ jsxs4(
      "div",
      {
        className: cn(
          "flex items-center gap-2 text-xs py-1 px-2 rounded cursor-pointer",
          selectedSlice === i ? "bg-ac-highlight/20 text-ac-text" : "hover:bg-ac-accent/20 text-ac-muted"
        ),
        onClick: () => onSliceSelect(i),
        children: [
          /* @__PURE__ */ jsx4(
            "button",
            {
              onClick: (e) => {
                e.stopPropagation();
                onSlicePlay(i);
              },
              className: cn(
                "p-0.5 rounded transition-colors",
                isPlaying && selectedSlice === i ? "text-red-400 hover:text-red-300" : "text-ac-muted hover:text-ac-text"
              ),
              title: isPlaying && selectedSlice === i ? "Stop" : "Play slice",
              children: isPlaying && selectedSlice === i ? /* @__PURE__ */ jsxs4("svg", { className: "w-3.5 h-3.5", fill: "currentColor", viewBox: "0 0 24 24", children: [
                /* @__PURE__ */ jsx4("rect", { x: "6", y: "5", width: "4", height: "14", rx: "1" }),
                /* @__PURE__ */ jsx4("rect", { x: "14", y: "5", width: "4", height: "14", rx: "1" })
              ] }) : /* @__PURE__ */ jsx4("svg", { className: "w-3.5 h-3.5", fill: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx4("path", { d: "M8 5v14l11-7z" }) })
            }
          ),
          /* @__PURE__ */ jsx4("span", { className: "font-medium flex-1", children: slice.label }),
          /* @__PURE__ */ jsxs4("span", { className: "text-ac-muted", children: [
            ((slice.endSample - slice.startSample) / sampleRate * 1e3).toFixed(0),
            "ms"
          ] }),
          triggerAssignments && onStartLearn && /* @__PURE__ */ jsx4(
            TriggerControls,
            {
              sliceIndex: i,
              triggerAssignments,
              learningSliceIndex: learningSliceIndex != null ? learningSliceIndex : null,
              onStartLearn,
              onCancelLearn,
              onClearTrigger
            }
          ),
          editable && onSliceDelete && /* @__PURE__ */ jsx4(
            "button",
            {
              onClick: (e) => {
                e.stopPropagation();
                onSliceDelete(i);
              },
              disabled: slices.length <= 1,
              className: cn(
                "text-red-400 hover:text-red-300 px-1",
                slices.length <= 1 && "opacity-30 cursor-not-allowed"
              ),
              title: "Delete slice",
              children: "\xD7"
            }
          )
        ]
      },
      i
    ))
  ] });
}

// src/ui/hooks/useAudioPreview.ts
import { useRef as useRef4, useState as useState5, useCallback as useCallback5, useEffect as useEffect4 } from "react";
import {
  createWebAudioOscillatorFactory,
  createPlaybackPositionTracker
} from "@audiocontrol/synth-core";
function useAudioPreview({ sampleRate }) {
  const audioContextRef = useRef4(null);
  const factoryRef = useRef4(null);
  const trackerRef = useRef4(null);
  const oscillatorRef = useRef4(null);
  const animationFrameRef = useRef4(null);
  const playbackPositionRef = useRef4(null);
  const startSampleRef = useRef4(0);
  const [isPlaying, setIsPlaying] = useState5(false);
  const [playbackPosition, setPlaybackPosition] = useState5(null);
  const [error, setError] = useState5(null);
  const getOrCreateEngine = useCallback5(() => {
    if (audioContextRef.current && factoryRef.current && trackerRef.current) {
      if (audioContextRef.current.state === "suspended") {
        audioContextRef.current.resume();
      }
      return {
        ctx: audioContextRef.current,
        factory: factoryRef.current,
        tracker: trackerRef.current
      };
    }
    try {
      const ctx = new AudioContext();
      audioContextRef.current = ctx;
      factoryRef.current = createWebAudioOscillatorFactory(ctx);
      trackerRef.current = createPlaybackPositionTracker(ctx);
      return { ctx, factory: factoryRef.current, tracker: trackerRef.current };
    } catch (e) {
      setError("Failed to create audio context");
      return null;
    }
  }, []);
  const updatePlaybackPosition = useCallback5(() => {
    const tracker = trackerRef.current;
    const osc = oscillatorRef.current;
    if (!tracker || !osc || !osc.isPlaying) {
      setPlaybackPosition(null);
      playbackPositionRef.current = null;
      setIsPlaying(false);
      return;
    }
    const currentSample = startSampleRef.current + tracker.getCurrentSample();
    playbackPositionRef.current = currentSample;
    setPlaybackPosition(currentSample);
    animationFrameRef.current = requestAnimationFrame(updatePlaybackPosition);
  }, []);
  const stop = useCallback5(() => {
    if (oscillatorRef.current) {
      oscillatorRef.current.stop(0);
      oscillatorRef.current = null;
    }
    if (trackerRef.current) {
      trackerRef.current.stop();
    }
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }
    setIsPlaying(false);
    setPlaybackPosition(null);
    playbackPositionRef.current = null;
  }, []);
  const play = useCallback5(
    (samples, startSample = 0, endSample) => {
      stop();
      const engine = getOrCreateEngine();
      if (!engine) return;
      setError(null);
      try {
        const end = endSample != null ? endSample : samples.length;
        if (end <= startSample) {
          setError("No audio to play");
          return;
        }
        engine.factory.setBuffer(samples, sampleRate);
        const osc = engine.factory.createSliceOscillator(startSample, end, 127);
        oscillatorRef.current = osc;
        startSampleRef.current = startSample;
        engine.tracker.start(sampleRate);
        setIsPlaying(true);
        animationFrameRef.current = requestAnimationFrame(updatePlaybackPosition);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Playback failed");
        setIsPlaying(false);
      }
    },
    [stop, getOrCreateEngine, sampleRate, updatePlaybackPosition]
  );
  useEffect4(() => {
    return () => {
      var _a, _b;
      stop();
      (_a = trackerRef.current) == null ? void 0 : _a.dispose();
      trackerRef.current = null;
      (_b = factoryRef.current) == null ? void 0 : _b.dispose();
      factoryRef.current = null;
      if (audioContextRef.current) {
        audioContextRef.current.close();
        audioContextRef.current = null;
      }
    };
  }, [stop]);
  return {
    play,
    stop,
    isPlaying,
    playbackPosition,
    playbackPositionRef,
    error
  };
}

// src/ui/hooks/useSampleChopper.ts
import { useState as useState7, useCallback as useCallback7, useMemo, useEffect as useEffect5 } from "react";

// src/audio-utils.ts
function msToSamples(ms, sampleRate) {
  return Math.round(ms * sampleRate / 1e3);
}
function samplesToMs(samples, sampleRate) {
  return samples * 1e3 / sampleRate;
}
function calculateRms(samples, start, length) {
  if (length <= 0) {
    return 0;
  }
  const end = Math.min(start + length, samples.length);
  const actualLength = end - start;
  if (actualLength <= 0) {
    return 0;
  }
  let sumSquares = 0;
  for (let i = start; i < end; i++) {
    const normalized = samples[i] / 32768;
    sumSquares += normalized * normalized;
  }
  return Math.sqrt(sumSquares / actualLength);
}
function amplitudeToDb(amplitude) {
  if (amplitude <= 0) {
    return -Infinity;
  }
  return 20 * Math.log10(amplitude);
}
function dbToAmplitude(db) {
  if (!Number.isFinite(db)) {
    return 0;
  }
  return Math.pow(10, db / 20);
}

// src/fixed-slicer.ts
function sliceByFixedInterval(samples, sampleRate, config) {
  const totalDurationMs = samplesToMs(samples.length, sampleRate);
  let intervalSamples;
  let sliceCount;
  if (config.intervalMs !== void 0) {
    intervalSamples = msToSamples(config.intervalMs, sampleRate);
    if (intervalSamples <= 0) {
      throw new Error(`Invalid interval: ${config.intervalMs}ms results in 0 samples at ${sampleRate}Hz`);
    }
    sliceCount = config.count;
  } else {
    if (config.count <= 0) {
      throw new Error(`Invalid count: ${config.count} (must be > 0)`);
    }
    sliceCount = config.count;
    intervalSamples = Math.floor(samples.length / sliceCount);
    if (intervalSamples <= 0) {
      throw new Error(`Audio too short for ${config.count} slices at ${sampleRate}Hz`);
    }
  }
  const slices = [];
  for (let i = 0; i < sliceCount; i++) {
    const startSample = i * intervalSamples;
    const endSample = i === sliceCount - 1 ? samples.length : Math.min(startSample + intervalSamples, samples.length);
    if (startSample >= samples.length) break;
    const sliceSamples = samples.slice(startSample, endSample);
    slices.push({
      index: i,
      startSample,
      endSample,
      samples: sliceSamples,
      durationMs: samplesToMs(sliceSamples.length, sampleRate)
    });
  }
  return {
    slices,
    sampleRate,
    totalDurationMs
  };
}

// src/silence-detector.ts
function sliceBySilence(samples, sampleRate, config) {
  const windowSizeSamples = msToSamples(10, sampleRate);
  const minSilenceSamples = msToSamples(config.minSilenceMs, sampleRate);
  const minSampleSamples = config.minSampleMs !== void 0 ? msToSamples(config.minSampleMs, sampleRate) : 0;
  const thresholdAmplitude = dbToAmplitude(config.thresholdDb);
  const totalDurationMs = samplesToMs(samples.length, sampleRate);
  const regions = [];
  let currentState = "silence";
  let regionStart = 0;
  for (let pos = 0; pos < samples.length; pos += windowSizeSamples) {
    const windowLength = Math.min(windowSizeSamples, samples.length - pos);
    const rms = calculateRms(samples, pos, windowLength);
    const db = amplitudeToDb(rms);
    const isSound = db > config.thresholdDb;
    const newState = isSound ? "sound" : "silence";
    if (newState !== currentState) {
      if (pos > regionStart) {
        regions.push({
          start: regionStart,
          end: pos,
          state: currentState
        });
      }
      regionStart = pos;
      currentState = newState;
    }
  }
  if (samples.length > regionStart) {
    regions.push({
      start: regionStart,
      end: samples.length,
      state: currentState
    });
  }
  const mergedRegions = [];
  for (const region of regions) {
    if (region.state === "silence" && region.end - region.start < minSilenceSamples) {
      if (mergedRegions.length > 0 && mergedRegions[mergedRegions.length - 1].state === "sound") {
        mergedRegions[mergedRegions.length - 1].end = region.end;
        continue;
      }
    }
    mergedRegions.push(__spreadValues({}, region));
  }
  const finalRegions = [];
  for (const region of mergedRegions) {
    if (finalRegions.length > 0 && region.state === "sound" && finalRegions[finalRegions.length - 1].state === "sound") {
      finalRegions[finalRegions.length - 1].end = region.end;
    } else {
      finalRegions.push(__spreadValues({}, region));
    }
  }
  const slices = [];
  let sliceIndex = 0;
  for (const region of finalRegions) {
    if (region.state === "sound") {
      const length = region.end - region.start;
      if (length < minSampleSamples) {
        continue;
      }
      const sliceSamples = samples.slice(region.start, region.end);
      slices.push({
        index: sliceIndex,
        startSample: region.start,
        endSample: region.end,
        samples: sliceSamples,
        durationMs: samplesToMs(length, sampleRate)
      });
      sliceIndex++;
    }
  }
  return {
    slices,
    sampleRate,
    totalDurationMs
  };
}

// src/transient-detector.ts
function sliceByTransient(samples, sampleRate, config) {
  const windowSizeMs = 10;
  const windowSizeSamples = msToSamples(windowSizeMs, sampleRate);
  const hopSizeSamples = msToSamples(5, sampleRate);
  const minGapSamples = msToSamples(config.minGapMs, sampleRate);
  const prePadSamples = config.prePadMs !== void 0 ? msToSamples(config.prePadMs, sampleRate) : msToSamples(5, sampleRate);
  const postPadSamples = config.postPadMs !== void 0 ? msToSamples(config.postPadMs, sampleRate) : 0;
  const totalDurationMs = samplesToMs(samples.length, sampleRate);
  const rmsValues = [];
  const windowPositions = [];
  for (let pos = 0; pos + windowSizeSamples <= samples.length; pos += hopSizeSamples) {
    const rms = calculateRms(samples, pos, windowSizeSamples);
    rmsValues.push(rms);
    windowPositions.push(pos);
  }
  const onsets = detectOnsets(rmsValues, windowPositions, config.threshold, minGapSamples);
  if (onsets.length === 0) {
    return {
      slices: [{
        index: 0,
        startSample: 0,
        endSample: samples.length,
        samples: samples.slice(),
        durationMs: totalDurationMs
      }],
      sampleRate,
      totalDurationMs
    };
  }
  const slices = [];
  for (let i = 0; i < onsets.length; i++) {
    const onset = onsets[i];
    const nextOnset = onsets[i + 1];
    let startSample = Math.max(0, onset.sampleIndex - prePadSamples);
    if (i > 0) {
      const prevEnd = slices[i - 1].endSample;
      startSample = Math.max(startSample, prevEnd);
    }
    let endSample;
    if (nextOnset) {
      endSample = Math.max(onset.sampleIndex + 1, nextOnset.sampleIndex - prePadSamples);
    } else {
      if (postPadSamples > 0) {
        endSample = findDecayEnd(samples, onset.sampleIndex, postPadSamples, sampleRate);
      } else {
        endSample = samples.length;
      }
    }
    const sliceSamples = samples.slice(startSample, endSample);
    slices.push({
      index: i,
      startSample,
      endSample,
      samples: sliceSamples,
      durationMs: samplesToMs(sliceSamples.length, sampleRate)
    });
  }
  return {
    slices,
    sampleRate,
    totalDurationMs
  };
}
function detectOnsets(rmsValues, windowPositions, threshold, minGapSamples) {
  const onsets = [];
  let wasAboveThreshold = false;
  let lastOnsetSample = -minGapSamples;
  for (let i = 0; i < rmsValues.length; i++) {
    const rms = rmsValues[i];
    const isAboveThreshold = rms >= threshold;
    if (isAboveThreshold && !wasAboveThreshold) {
      const sampleIndex = windowPositions[i];
      if (sampleIndex - lastOnsetSample >= minGapSamples) {
        onsets.push({
          sampleIndex,
          amplitude: rms
        });
        lastOnsetSample = sampleIndex;
      }
    }
    wasAboveThreshold = isAboveThreshold;
  }
  return onsets;
}
function findDecayEnd(samples, onsetSample, maxDurationSamples, sampleRate) {
  const windowSizeSamples = msToSamples(10, sampleRate);
  const silenceThreshold = 0.01;
  const maxEnd = Math.min(onsetSample + maxDurationSamples, samples.length);
  for (let pos = onsetSample; pos + windowSizeSamples <= maxEnd; pos += windowSizeSamples) {
    const rms = calculateRms(samples, pos, windowSizeSamples);
    if (rms < silenceThreshold) {
      return Math.min(pos + windowSizeSamples * 2, maxEnd);
    }
  }
  return maxEnd;
}

// src/manual-slicer.ts
function sliceByManualRegions(samples, sampleRate, config) {
  const totalDurationMs = samplesToMs(samples.length, sampleRate);
  const totalDurationSamples = samples.length;
  if (config.regions.length === 0) {
    throw new Error("Manual slicing requires at least one region");
  }
  const validatedRegions = validateRegions(config.regions, totalDurationMs);
  const slices = validatedRegions.map((region, index) => {
    const startSample = msToSamples(region.start, sampleRate);
    const endSample = Math.min(msToSamples(region.end, sampleRate), totalDurationSamples);
    const sliceSamples = samples.slice(startSample, endSample);
    return {
      index,
      startSample,
      endSample,
      samples: sliceSamples,
      durationMs: samplesToMs(sliceSamples.length, sampleRate),
      name: region.name
    };
  });
  return {
    slices,
    sampleRate,
    totalDurationMs
  };
}
function validateRegions(regions, totalDurationMs) {
  var _a, _b, _c;
  const errors = [];
  for (let i = 0; i < regions.length; i++) {
    const region = regions[i];
    const label = (_a = region.name) != null ? _a : `Region ${i + 1}`;
    if (region.start < 0) {
      errors.push(`${label}: start time (${region.start}ms) cannot be negative`);
    }
    if (region.end <= region.start) {
      errors.push(`${label}: end time (${region.end}ms) must be greater than start time (${region.start}ms)`);
    }
    if (region.start > totalDurationMs) {
      errors.push(`${label}: start time (${region.start}ms) exceeds audio duration (${totalDurationMs.toFixed(1)}ms)`);
    }
  }
  if (errors.length > 0) {
    throw new Error(`Invalid manual regions:
  - ${errors.join("\n  - ")}`);
  }
  const sorted = [...regions].sort((a, b) => a.start - b.start);
  for (let i = 1; i < sorted.length; i++) {
    const prev = sorted[i - 1];
    const curr = sorted[i];
    if (curr.start < prev.end) {
      const prevLabel = (_b = prev.name) != null ? _b : `Region ${i}`;
      const currLabel = (_c = curr.name) != null ? _c : `Region ${i + 1}`;
      console.warn(
        `Warning: ${currLabel} (${curr.start}ms) overlaps with ${prevLabel} (ends at ${prev.end}ms)`
      );
    }
  }
  return sorted;
}

// src/chopper.ts
function sliceAudio(samples, sampleRate, config) {
  switch (config.method) {
    case "fixed":
      return sliceByFixedInterval(samples, sampleRate, config);
    case "silence":
      return sliceBySilence(samples, sampleRate, config);
    case "transient":
      return sliceByTransient(samples, sampleRate, config);
    case "manual":
      return sliceByManualRegions(samples, sampleRate, config);
    default:
      const exhaustiveCheck = config;
      throw new Error(`Unknown slice method: ${exhaustiveCheck.method}`);
  }
}
function analyzeForSlicing(samples, sampleRate) {
  let maxAbs = 0;
  for (let i = 0; i < samples.length; i++) {
    const abs = Math.abs(samples[i]);
    if (abs > maxAbs) {
      maxAbs = abs;
    }
  }
  const peakAmplitude = maxAbs / 32768;
  const suggestedTransientThreshold = Math.max(0.1, peakAmplitude * 0.3);
  const suggestedSilenceThresholdDb = -40;
  return {
    duration: {
      ms: samples.length / sampleRate * 1e3,
      samples: samples.length
    },
    peakAmplitude,
    suggestedTransientThreshold,
    suggestedSilenceThresholdDb
  };
}

// src/types.ts
var DEFAULT_SLICE_LABELS = ["S1", "S2", "S3", "S4"];

// src/ui/hooks/useSliceHistory.ts
import { useState as useState6, useCallback as useCallback6, useRef as useRef5 } from "react";
var MAX_HISTORY = 50;
function useSliceHistory() {
  const [entries, setEntries] = useState6([]);
  const [currentIndex, setCurrentIndex] = useState6(-1);
  const lastLabelRef = useRef5(null);
  const currentIndexRef = useRef5(-1);
  currentIndexRef.current = currentIndex;
  const push = useCallback6((slices, label) => {
    const snapshot = slices.map((s) => __spreadValues({}, s));
    const entry = { label, slices: snapshot, timestamp: Date.now() };
    setEntries((prev) => {
      const ci = currentIndexRef.current;
      const base = ci >= 0 ? prev.slice(0, ci + 1) : [];
      if (base.length > 0 && lastLabelRef.current === label) {
        const coalesced = [...base];
        coalesced[coalesced.length - 1] = entry;
        return coalesced;
      }
      const updated = [...base, entry];
      if (updated.length > MAX_HISTORY) {
        const trimmed = updated.slice(updated.length - MAX_HISTORY);
        const newIdx2 = trimmed.length - 1;
        currentIndexRef.current = newIdx2;
        setCurrentIndex(newIdx2);
        lastLabelRef.current = label;
        return trimmed;
      }
      const newIdx = updated.length - 1;
      currentIndexRef.current = newIdx;
      setCurrentIndex(newIdx);
      lastLabelRef.current = label;
      return updated;
    });
  }, []);
  const undo = useCallback6(() => {
    const ci = currentIndexRef.current;
    if (ci <= 0) return null;
    const newIndex = ci - 1;
    currentIndexRef.current = newIndex;
    setCurrentIndex(newIndex);
    lastLabelRef.current = null;
    let result = null;
    setEntries((prev) => {
      var _a, _b;
      result = (_b = (_a = prev[newIndex]) == null ? void 0 : _a.slices.map((s) => __spreadValues({}, s))) != null ? _b : null;
      return prev;
    });
    return result;
  }, []);
  const redo = useCallback6(() => {
    let result = null;
    setEntries((prev) => {
      var _a, _b;
      const ci = currentIndexRef.current;
      if (ci >= prev.length - 1) return prev;
      const newIndex = ci + 1;
      currentIndexRef.current = newIndex;
      setCurrentIndex(newIndex);
      lastLabelRef.current = null;
      result = (_b = (_a = prev[newIndex]) == null ? void 0 : _a.slices.map((s) => __spreadValues({}, s))) != null ? _b : null;
      return prev;
    });
    return result;
  }, []);
  const restore = useCallback6((index) => {
    currentIndexRef.current = index;
    setCurrentIndex(index);
    lastLabelRef.current = null;
    return entries[index].slices.map((s) => __spreadValues({}, s));
  }, [entries]);
  const clear = useCallback6(() => {
    setEntries([]);
    currentIndexRef.current = -1;
    setCurrentIndex(-1);
    lastLabelRef.current = null;
  }, []);
  return {
    push,
    undo,
    redo,
    canUndo: currentIndex > 0,
    canRedo: currentIndex < entries.length - 1,
    entries,
    currentIndex,
    restore,
    clear
  };
}

// src/ui/hooks/useSampleChopper.ts
var DEFAULT_MIN_SLICE_SAMPLES = 500;
var MIN_SAMPLES_AFTER_STRIP = 100;
var MIN_ZOOM2 = 1;
var MAX_ZOOM2 = 64;
var ZOOM_STEP2 = 1.5;
function findFirstAboveThreshold(samples, startSample, endSample, thresholdDb) {
  const threshold = Math.pow(10, thresholdDb / 20) * 32768;
  for (let i = startSample; i < endSample; i++) {
    if (Math.abs(samples[i]) >= threshold) return i;
  }
  return startSample;
}
function findLastAboveThreshold(samples, startSample, endSample, thresholdDb) {
  const threshold = Math.pow(10, thresholdDb / 20) * 32768;
  for (let i = endSample - 1; i >= startSample; i--) {
    if (Math.abs(samples[i]) >= threshold) return i + 1;
  }
  return endSample;
}
function useSampleChopper({
  samples,
  sampleRate,
  open,
  editMode,
  initialSlices,
  labels: externalLabels
}) {
  var _a;
  const [isFullscreen, setIsFullscreen] = useState7(false);
  const [zoom, setZoom] = useState7(1);
  const [joinedEdges, setJoinedEdges] = useState7(true);
  const [stripSilenceThreshold, setStripSilenceThreshold] = useState7(-40);
  const [stripSilenceActive, setStripSilenceActive] = useState7(false);
  const [originalSliceBoundaries, setOriginalSliceBoundaries] = useState7([]);
  const [selectedMethod, setSelectedMethod] = useState7("manual");
  const [useInitialSlices, setUseInitialSlices] = useState7(editMode && !!initialSlices);
  const [transientThreshold, setTransientThreshold] = useState7(0.3);
  const [transientMinGap, setTransientMinGap] = useState7(100);
  const [transientPrePad, setTransientPrePad] = useState7(5);
  const [fixedCount, setFixedCount] = useState7(16);
  const [kitLabels, setKitLabels] = useState7(externalLabels != null ? externalLabels : DEFAULT_SLICE_LABELS.join(","));
  const [autoSliceResult, setAutoSliceResult] = useState7(null);
  const [selectedSlice, setSelectedSlice] = useState7(void 0);
  const [sliceError, setSliceError] = useState7(null);
  const [manualSlices, setManualSlices] = useState7(
    (_a = initialSlices == null ? void 0 : initialSlices.map((s) => __spreadValues({}, s))) != null ? _a : []
  );
  const history = useSliceHistory();
  useEffect5(() => {
    if (open) {
      setZoom(1);
      setIsFullscreen(false);
    }
  }, [open]);
  useEffect5(() => {
    setAutoSliceResult(null);
    setManualSlices([]);
    setSelectedSlice(void 0);
    setSliceError(null);
    setOriginalSliceBoundaries([]);
    setUseInitialSlices(false);
    history.clear();
  }, [samples]);
  useEffect5(() => {
    if (open && editMode && initialSlices && initialSlices.length > 0) {
      setKitLabels(initialSlices.map((s) => s.label).join(","));
      const slices = initialSlices.map((s) => __spreadValues({}, s));
      setManualSlices(slices);
      setUseInitialSlices(true);
      setSelectedMethod("manual");
      history.clear();
      history.push(slices, "Load slices");
    }
  }, [open, editMode, initialSlices]);
  useEffect5(() => {
    if (open && samples && samples.length > 0) {
      const analysis = analyzeForSlicing(samples, sampleRate);
      setTransientThreshold(Math.round(analysis.suggestedTransientThreshold * 100) / 100);
      setStripSilenceThreshold(analysis.suggestedSilenceThresholdDb);
      if (analysis.duration.ms >= 1e3) {
        const estimatedBeats = Math.round(analysis.duration.ms / 500);
        if (estimatedBeats >= 2 && estimatedBeats <= 16) {
          setFixedCount(estimatedBeats);
        }
      }
    }
  }, [open, samples, sampleRate]);
  const sliceConfig = useMemo(() => {
    switch (selectedMethod) {
      case "transient":
        return { method: "transient", threshold: transientThreshold, minGapMs: transientMinGap, prePadMs: transientPrePad };
      case "fixed":
        return { method: "fixed", count: fixedCount };
      case "manual":
        return { method: "transient", threshold: transientThreshold, minGapMs: transientMinGap, prePadMs: transientPrePad };
    }
  }, [selectedMethod, transientThreshold, transientMinGap, transientPrePad, fixedCount]);
  useEffect5(() => {
    if (!samples || samples.length === 0) {
      setAutoSliceResult(null);
      return;
    }
    if (selectedMethod === "manual") {
      setAutoSliceResult(null);
      return;
    }
    if (useInitialSlices) {
      return;
    }
    try {
      const result = sliceAudio(samples, sampleRate, sliceConfig);
      setAutoSliceResult(result);
      setSliceError(null);
      setSelectedSlice(void 0);
    } catch (err) {
      setSliceError(err instanceof Error ? err.message : "Slicing failed");
      setAutoSliceResult(null);
    }
  }, [samples, sampleRate, sliceConfig, selectedMethod, useInitialSlices]);
  const currentSliceResult = useMemo(() => {
    if (!samples || samples.length === 0) return null;
    if (selectedMethod === "manual" || useInitialSlices) {
      if (manualSlices.length === 0) return null;
      const totalDurationMs = samples.length / sampleRate * 1e3;
      return {
        slices: manualSlices.map((slice, index) => ({
          index,
          startSample: slice.startSample,
          endSample: slice.endSample,
          samples: samples.slice(slice.startSample, slice.endSample),
          durationMs: (slice.endSample - slice.startSample) / sampleRate * 1e3
        })),
        sampleRate,
        totalDurationMs
      };
    }
    return autoSliceResult;
  }, [samples, sampleRate, selectedMethod, useInitialSlices, manualSlices, autoSliceResult]);
  const computeStrippedBoundaries = useCallback7(
    (originalStart, originalEnd, threshold) => {
      if (!samples) return { startSample: originalStart, endSample: originalEnd };
      const newStart = findFirstAboveThreshold(samples, originalStart, originalEnd, threshold);
      const newEnd = findLastAboveThreshold(samples, originalStart, originalEnd, threshold);
      if (newEnd - newStart < MIN_SAMPLES_AFTER_STRIP) {
        return { startSample: originalStart, endSample: originalEnd };
      }
      return { startSample: newStart, endSample: newEnd };
    },
    [samples]
  );
  const strippedPreview = useMemo(() => {
    if (!stripSilenceActive || originalSliceBoundaries.length === 0) return null;
    return originalSliceBoundaries.map(
      (original) => computeStrippedBoundaries(original.startSample, original.endSample, stripSilenceThreshold)
    );
  }, [stripSilenceActive, originalSliceBoundaries, stripSilenceThreshold, computeStrippedBoundaries]);
  const sliceMarkers = useMemo(() => {
    if (selectedMethod === "manual" || useInitialSlices) {
      if (stripSilenceActive && strippedPreview) {
        return manualSlices.map((slice, i) => {
          var _a2, _b, _c, _d;
          return {
            startSample: (_b = (_a2 = strippedPreview[i]) == null ? void 0 : _a2.startSample) != null ? _b : slice.startSample,
            endSample: (_d = (_c = strippedPreview[i]) == null ? void 0 : _c.endSample) != null ? _d : slice.endSample,
            label: slice.label
          };
        });
      }
      return manualSlices.map((slice) => ({
        startSample: slice.startSample,
        endSample: slice.endSample,
        label: slice.label
      }));
    }
    if (!autoSliceResult) return [];
    const labels = kitLabels.split(",").map((s) => s.trim().toUpperCase());
    return autoSliceResult.slices.map((slice, i) => {
      var _a2;
      return {
        startSample: slice.startSample,
        endSample: slice.endSample,
        label: (_a2 = labels[i % labels.length]) != null ? _a2 : `${i + 1}`
      };
    });
  }, [selectedMethod, useInitialSlices, manualSlices, autoSliceResult, kitLabels, stripSilenceActive, strippedPreview]);
  const handleSliceChange = useCallback7((index, marker) => {
    setManualSlices((prev) => {
      const updated = [...prev];
      if (updated[index]) {
        updated[index] = __spreadProps(__spreadValues({}, updated[index]), { startSample: marker.startSample, endSample: marker.endSample });
      }
      history.push(updated, "Adjust edge");
      return updated;
    });
  }, [history.push]);
  const handleSlicesChange = useCallback7((changes) => {
    setManualSlices((prev) => {
      const updated = [...prev];
      for (const change of changes) {
        if (updated[change.index]) {
          updated[change.index] = __spreadProps(__spreadValues({}, updated[change.index]), {
            startSample: change.marker.startSample,
            endSample: change.marker.endSample
          });
        }
      }
      history.push(updated, "Adjust edges");
      return updated;
    });
  }, [history.push]);
  const handleSliceAdd = useCallback7((samplePosition) => {
    if (!samples) return;
    const labels = kitLabels.split(",").map((s) => s.trim());
    setManualSlices((prev) => {
      var _a2, _b;
      const newSlices = [...prev];
      for (let i = 0; i < newSlices.length; i++) {
        const slice = newSlices[i];
        if (samplePosition > slice.startSample + DEFAULT_MIN_SLICE_SAMPLES && samplePosition < slice.endSample - DEFAULT_MIN_SLICE_SAMPLES) {
          const originalEnd = slice.endSample;
          newSlices[i] = __spreadProps(__spreadValues({}, slice), { endSample: samplePosition });
          newSlices.splice(i + 1, 0, {
            label: (_a2 = labels[(i + 1) % labels.length]) != null ? _a2 : `S${newSlices.length + 1}`,
            startSample: samplePosition,
            endSample: originalEnd
          });
          history.push(newSlices, "Split slice");
          return newSlices;
        }
      }
      let endSample = samples.length;
      for (const slice of newSlices) {
        if (slice.startSample > samplePosition && slice.startSample < endSample) {
          endSample = slice.startSample;
        }
      }
      let startSample = samplePosition;
      for (const slice of newSlices) {
        if (slice.endSample <= samplePosition && slice.endSample > startSample - (endSample - samplePosition)) {
          startSample = slice.endSample;
        }
      }
      if (endSample - startSample < DEFAULT_MIN_SLICE_SAMPLES) {
        endSample = Math.min(startSample + DEFAULT_MIN_SLICE_SAMPLES, samples.length);
      }
      const newSlice = {
        label: (_b = labels[newSlices.length % labels.length]) != null ? _b : `S${newSlices.length + 1}`,
        startSample,
        endSample
      };
      const insertIndex = newSlices.findIndex((s) => s.startSample > startSample);
      if (insertIndex === -1) {
        newSlices.push(newSlice);
      } else {
        newSlices.splice(insertIndex, 0, newSlice);
      }
      history.push(newSlices, "Add slice");
      return newSlices;
    });
  }, [samples, kitLabels, history.push]);
  const handleSliceDelete = useCallback7((index) => {
    setManualSlices((prev) => {
      if (prev.length <= 1) return prev;
      const updated = [...prev];
      updated.splice(index, 1);
      history.push(updated, "Delete slice");
      return updated;
    });
    setSelectedSlice(void 0);
  }, [history.push]);
  const handleApplyStripSilence = useCallback7(() => {
    if (!strippedPreview) return;
    setManualSlices((prev) => {
      const updated = prev.map((slice, i) => {
        var _a2, _b, _c, _d;
        return __spreadProps(__spreadValues({}, slice), {
          startSample: (_b = (_a2 = strippedPreview[i]) == null ? void 0 : _a2.startSample) != null ? _b : slice.startSample,
          endSample: (_d = (_c = strippedPreview[i]) == null ? void 0 : _c.endSample) != null ? _d : slice.endSample
        });
      });
      history.push(updated, "Strip silence");
      return updated;
    });
    setStripSilenceActive(false);
    setOriginalSliceBoundaries([]);
  }, [strippedPreview, history.push]);
  const handleCancelStripSilence = useCallback7(() => {
    setStripSilenceActive(false);
    setOriginalSliceBoundaries([]);
  }, []);
  const handleZoomIn = useCallback7(() => {
    setZoom((prev) => Math.min(MAX_ZOOM2, prev * ZOOM_STEP2));
  }, []);
  const handleZoomOut = useCallback7(() => {
    setZoom((prev) => Math.max(MIN_ZOOM2, prev / ZOOM_STEP2));
  }, []);
  const handleZoomReset = useCallback7(() => {
    setZoom(1);
  }, []);
  const handleApplyAutoSlice = useCallback7(() => {
    if (!autoSliceResult || autoSliceResult.slices.length === 0) return;
    const labels = kitLabels.split(",").map((s) => s.trim());
    const slices = autoSliceResult.slices.map((slice, i) => {
      var _a2;
      return {
        label: (_a2 = labels[i % labels.length]) != null ? _a2 : `S${i + 1}`,
        startSample: slice.startSample,
        endSample: slice.endSample
      };
    });
    setManualSlices(slices);
    history.push(slices, `Apply ${selectedMethod}`);
    setSelectedMethod("manual");
    setUseInitialSlices(false);
  }, [autoSliceResult, kitLabels, selectedMethod, history.push]);
  const handleSwitchToManual = useCallback7(() => {
    setSelectedMethod("manual");
    setUseInitialSlices(false);
  }, []);
  const handleMethodChange = useCallback7((newMethod) => {
    setSelectedMethod(newMethod);
    if (newMethod !== "manual") {
      setUseInitialSlices(false);
    }
    setStripSilenceActive(false);
    setOriginalSliceBoundaries([]);
  }, []);
  const handleUndo = useCallback7(() => {
    const slices = history.undo();
    if (slices) {
      setManualSlices(slices);
      setSelectedSlice(void 0);
    }
  }, [history.undo]);
  const handleRedo = useCallback7(() => {
    const slices = history.redo();
    if (slices) {
      setManualSlices(slices);
      setSelectedSlice(void 0);
    }
  }, [history.redo]);
  const handleRestoreHistory = useCallback7((index) => {
    const slices = history.restore(index);
    setManualSlices(slices);
    setSelectedSlice(void 0);
  }, [history.restore]);
  const activateStripSilence = useCallback7(() => {
    if (manualSlices.length === 0) return;
    setOriginalSliceBoundaries(manualSlices.map((s) => ({ startSample: s.startSample, endSample: s.endSample })));
    setStripSilenceActive(true);
  }, [manualSlices]);
  const durationMs = samples ? samples.length / sampleRate * 1e3 : 0;
  const isManualMode = selectedMethod === "manual";
  return {
    isFullscreen,
    setIsFullscreen,
    zoom,
    setZoom,
    handleZoomIn,
    handleZoomOut,
    handleZoomReset,
    joinedEdges,
    setJoinedEdges,
    stripSilenceThreshold,
    setStripSilenceThreshold,
    stripSilenceActive,
    strippedPreview,
    originalSliceBoundaries,
    handleApplyStripSilence,
    handleCancelStripSilence,
    activateStripSilence,
    selectedMethod,
    handleMethodChange,
    transientThreshold,
    setTransientThreshold,
    transientMinGap,
    setTransientMinGap,
    transientPrePad,
    setTransientPrePad,
    fixedCount,
    setFixedCount,
    kitLabels,
    setKitLabels,
    autoSliceResult,
    currentSliceResult,
    selectedSlice,
    setSelectedSlice,
    sliceError,
    sliceMarkers,
    manualSlices,
    setManualSlices,
    handleSliceChange,
    handleSlicesChange,
    handleSliceAdd,
    handleSliceDelete,
    handleApplyAutoSlice,
    handleSwitchToManual,
    durationMs,
    isManualMode,
    useInitialSlices,
    handleUndo,
    handleRedo,
    handleRestoreHistory,
    canUndo: history.canUndo,
    canRedo: history.canRedo,
    historyEntries: history.entries,
    historyIndex: history.currentIndex,
    pushHistory: history.push
  };
}

// src/ui/hooks/useTriggerRecorder.ts
import { useState as useState8, useCallback as useCallback8, useMemo as useMemo2, useRef as useRef6 } from "react";
function useTriggerRecorder({
  playbackPositionRef,
  isPlaying,
  onPlay,
  onStop,
  onRetrigger,
  totalSamples,
  kitLabels
}) {
  const [triggerEvents, setTriggerEvents] = useState8([]);
  const seenTriggerIdsRef = useRef6(/* @__PURE__ */ new Set());
  const onRetriggerRef = useRef6(onRetrigger);
  onRetriggerRef.current = onRetrigger;
  const preventAutoCompleteRef = useRef6(false);
  const handleTrigger = useCallback8((samplePosition, triggerId) => {
    if (seenTriggerIdsRef.current.has(triggerId)) {
      preventAutoCompleteRef.current = true;
      onRetriggerRef.current(triggerId);
      return;
    }
    if (samplePosition < 0) return;
    seenTriggerIdsRef.current.add(triggerId);
    setTriggerEvents((prev) => [...prev, { samplePosition, triggerId }]);
  }, []);
  const triggerInput = useTriggerInput({
    playbackPositionRef,
    isPlaying,
    onPlay,
    onStop,
    onTrigger: handleTrigger,
    preventAutoComplete: preventAutoCompleteRef
  });
  const { recordedSlices, triggerToSliceIndex } = useMemo2(() => {
    var _a;
    if (triggerEvents.length === 0) {
      return {
        recordedSlices: [],
        triggerToSliceIndex: /* @__PURE__ */ new Map()
      };
    }
    const labels = kitLabels.split(",").map((s) => s.trim());
    const sorted = [...triggerEvents].sort((a, b) => a.samplePosition - b.samplePosition);
    const deduped = [sorted[0]];
    for (let i = 1; i < sorted.length; i++) {
      if (sorted[i].samplePosition - deduped[deduped.length - 1].samplePosition > 100) {
        deduped.push(sorted[i]);
      }
    }
    const slices = [];
    const mapping = /* @__PURE__ */ new Map();
    for (let i = 0; i < deduped.length; i++) {
      const startSample = deduped[i].samplePosition;
      const endSample = i < deduped.length - 1 ? deduped[i + 1].samplePosition : totalSamples;
      slices.push({
        label: (_a = labels[i % labels.length]) != null ? _a : `S${i + 1}`,
        startSample,
        endSample
      });
      if (!mapping.has(deduped[i].triggerId)) {
        mapping.set(deduped[i].triggerId, i);
      }
    }
    return { recordedSlices: slices, triggerToSliceIndex: mapping };
  }, [triggerEvents, totalSamples, kitLabels]);
  const reset = useCallback8(() => {
    triggerInput.reset();
    setTriggerEvents([]);
    seenTriggerIdsRef.current.clear();
    preventAutoCompleteRef.current = false;
  }, [triggerInput]);
  return {
    state: triggerInput.state,
    midiAvailable: triggerInput.midiAvailable,
    triggerCount: triggerEvents.length,
    recordedSlices,
    triggerToSliceIndex,
    arm: triggerInput.arm,
    stopRecording: triggerInput.stopRecording,
    reset
  };
}

// src/ui/hooks/useTriggerMappings.ts
import { useState as useState9, useCallback as useCallback10, useMemo as useMemo4 } from "react";

// src/ui/hooks/useTriggerPlayback.ts
import { useCallback as useCallback9, useMemo as useMemo3 } from "react";
import { useSlicePlayer } from "@audiocontrol/synth-core";
var DEFAULT_PLAYBACK_CONFIG = {
  polyphony: "poly",
  playbackMode: "one-shot",
  muteGroups: []
};
function useTriggerPlayback({
  samples,
  sampleRate,
  slices,
  config
}) {
  const sliceDefinitions = useMemo3(
    () => slices.map((s) => ({ startSample: s.startSample, endSample: s.endSample })),
    [slices]
  );
  const maxPolyphony = config.polyphony === "mono" ? 1 : 16;
  const player = useSlicePlayer({
    samples,
    sampleRate,
    slices: sliceDefinitions,
    muteGroups: config.muteGroups,
    playbackMode: config.playbackMode,
    maxPolyphony
  });
  const playSlice = useCallback9((index) => {
    player.playSlice(index);
  }, [player.playSlice]);
  const stopSlice = useCallback9((index) => {
    player.stopSlice(index);
  }, [player.stopSlice]);
  const latencyMs = player.latencyMs === 0 ? null : player.latencyMs;
  return { playSlice, stopSlice, stopAll: player.stopAll, latencyMs };
}

// src/ui/hooks/useTriggerMappings.ts
function useTriggerMappings({
  initialTriggers,
  initialPlaybackConfig,
  recordedMapping
}) {
  const [playbackConfig, setPlaybackConfig] = useState9(
    initialPlaybackConfig != null ? initialPlaybackConfig : DEFAULT_PLAYBACK_CONFIG
  );
  const [learnedMappings, setLearnedMappings] = useState9(/* @__PURE__ */ new Map());
  const restoredMapping = useMemo4(() => {
    if (!initialTriggers || initialTriggers.length === 0) return null;
    const map = /* @__PURE__ */ new Map();
    for (const t of initialTriggers) {
      map.set(t.triggerId, t.sliceIndex);
    }
    return map;
  }, [initialTriggers]);
  const effectiveMapping = useMemo4(() => {
    const merged = /* @__PURE__ */ new Map();
    if (restoredMapping) {
      for (const [id, idx] of restoredMapping) merged.set(id, idx);
    }
    if (recordedMapping.size > 0) {
      for (const [id, idx] of recordedMapping) merged.set(id, idx);
    }
    for (const [id, idx] of learnedMappings) merged.set(id, idx);
    return merged;
  }, [restoredMapping, recordedMapping, learnedMappings]);
  const triggerMappings = useMemo4(() => {
    return [...effectiveMapping.entries()].map(([triggerId, sliceIndex]) => ({
      triggerId,
      sliceIndex
    }));
  }, [effectiveMapping]);
  const learnTrigger = useCallback10((sliceIndex, triggerId) => {
    setLearnedMappings((prev) => {
      const next = new Map(prev);
      for (const [id, idx] of next) {
        if (idx === sliceIndex) next.delete(id);
      }
      next.set(triggerId, sliceIndex);
      return next;
    });
  }, []);
  const clearLearnedTrigger = useCallback10((sliceIndex) => {
    setLearnedMappings((prev) => {
      const next = new Map(prev);
      for (const [id, idx] of next) {
        if (idx === sliceIndex) next.delete(id);
      }
      return next;
    });
  }, []);
  const clearAllLearnedTriggers = useCallback10(() => {
    setLearnedMappings(/* @__PURE__ */ new Map());
  }, []);
  const setPolyphony = useCallback10((mode) => {
    setPlaybackConfig((prev) => __spreadProps(__spreadValues({}, prev), { polyphony: mode }));
  }, []);
  const setPlaybackMode = useCallback10((mode) => {
    setPlaybackConfig((prev) => __spreadProps(__spreadValues({}, prev), { playbackMode: mode }));
  }, []);
  const setMuteGroup = useCallback10((sliceIndex, group) => {
    setPlaybackConfig((prev) => {
      const muteGroups = [...prev.muteGroups];
      muteGroups[sliceIndex] = group;
      return __spreadProps(__spreadValues({}, prev), { muteGroups });
    });
  }, []);
  const reset = useCallback10(() => {
    setLearnedMappings(/* @__PURE__ */ new Map());
    setPlaybackConfig(DEFAULT_PLAYBACK_CONFIG);
  }, []);
  return {
    effectiveMapping,
    triggerMappings,
    playbackConfig,
    setPolyphony,
    setPlaybackMode,
    setMuteGroup,
    learnTrigger,
    clearLearnedTrigger,
    clearAllLearnedTriggers,
    reset
  };
}

// src/ui/hooks/useTriggerPlaybackListeners.ts
import { useEffect as useEffect6, useRef as useRef7, useCallback as useCallback11 } from "react";
var IGNORED_KEYS3 = /* @__PURE__ */ new Set([
  "Shift",
  "Control",
  "Alt",
  "Meta",
  "CapsLock",
  "Tab",
  "Escape",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12"
]);
function useTriggerPlaybackListeners({
  active,
  midiLearnActive,
  state,
  slices,
  effectiveMapping,
  onPlaySlice,
  onStopSlice,
  playbackConfig
}) {
  const activeRef = useRef7(active);
  const midiLearnActiveRef = useRef7(midiLearnActive);
  const stateRef = useRef7(state);
  const slicesRef = useRef7(slices);
  const effectiveMappingRef = useRef7(effectiveMapping);
  const onPlaySliceRef = useRef7(onPlaySlice);
  const onStopSliceRef = useRef7(onStopSlice);
  const playbackConfigRef = useRef7(playbackConfig);
  activeRef.current = active;
  midiLearnActiveRef.current = midiLearnActive;
  stateRef.current = state;
  slicesRef.current = slices;
  effectiveMappingRef.current = effectiveMapping;
  onPlaySliceRef.current = onPlaySlice;
  onStopSliceRef.current = onStopSlice;
  playbackConfigRef.current = playbackConfig;
  const firePlayback = useCallback11((triggerId) => {
    if (slicesRef.current.length === 0) return;
    const index = effectiveMappingRef.current.get(triggerId);
    if (index !== void 0) {
      onPlaySliceRef.current(index);
    }
  }, []);
  const fireStopPlayback = useCallback11((triggerId) => {
    if (playbackConfigRef.current.playbackMode !== "gate") return;
    const index = effectiveMappingRef.current.get(triggerId);
    if (index !== void 0) {
      onStopSliceRef.current(index);
    }
  }, []);
  useEffect6(() => {
    const handleKeyDown = (event) => {
      if (!activeRef.current) return;
      if (midiLearnActiveRef.current) return;
      const s = stateRef.current;
      if (s !== "idle" && s !== "complete") return;
      if (slicesRef.current.length === 0) return;
      if (event.repeat) return;
      if (IGNORED_KEYS3.has(event.key)) return;
      const target = event.target;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT") return;
      const id = keyTriggerId(event.key);
      if (!effectiveMappingRef.current.has(id)) return;
      event.preventDefault();
      event.stopPropagation();
      firePlayback(id);
    };
    const handleKeyUp = (event) => {
      if (!activeRef.current) return;
      if (midiLearnActiveRef.current) return;
      const s = stateRef.current;
      if (s !== "idle" && s !== "complete") return;
      if (slicesRef.current.length === 0) return;
      const id = keyTriggerId(event.key);
      if (!effectiveMappingRef.current.has(id)) return;
      fireStopPlayback(id);
    };
    window.addEventListener("keydown", handleKeyDown, true);
    window.addEventListener("keyup", handleKeyUp, true);
    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
      window.removeEventListener("keyup", handleKeyUp, true);
    };
  }, [firePlayback, fireStopPlayback]);
  useEffect6(() => {
    if (!navigator.requestMIDIAccess) return;
    let inputs = null;
    const handleMidiMessage = (event) => {
      if (!activeRef.current) return;
      if (midiLearnActiveRef.current) return;
      const s = stateRef.current;
      if (s !== "idle" && s !== "complete") return;
      if (slicesRef.current.length === 0) return;
      const data = event.data;
      if (!data || data.length < 3) return;
      const status = data[0] & 240;
      const note = data[1];
      const velocity = data[2];
      if (status === 144 && velocity > 0) {
        const id = midiTriggerId(note);
        if (effectiveMappingRef.current.has(id)) {
          firePlayback(id);
        }
      } else if (status === 128 || status === 144 && velocity === 0) {
        const id = midiTriggerId(note);
        if (effectiveMappingRef.current.has(id)) {
          fireStopPlayback(id);
        }
      }
    };
    navigator.requestMIDIAccess().then(
      (access) => {
        inputs = access.inputs;
        inputs.forEach((input) => {
          input.addEventListener("midimessage", handleMidiMessage);
        });
      },
      () => {
      }
    );
    return () => {
      if (inputs) {
        inputs.forEach((input) => {
          input.removeEventListener("midimessage", handleMidiMessage);
        });
      }
    };
  }, [firePlayback, fireStopPlayback]);
}

// src/ui/components/ChangeHistory.tsx
import { useState as useState10 } from "react";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
function ChangeHistory({
  entries,
  currentIndex,
  onRestore
}) {
  const [expanded, setExpanded] = useState10(false);
  return /* @__PURE__ */ jsxs5("div", { className: "bg-ac-bg rounded", children: [
    /* @__PURE__ */ jsxs5(
      "button",
      {
        onClick: () => setExpanded((prev) => !prev),
        className: "w-full flex items-center justify-between px-3 py-2 text-xs text-ac-muted hover:text-ac-text transition-colors",
        children: [
          /* @__PURE__ */ jsxs5("span", { className: "uppercase tracking-wide", children: [
            "History (",
            entries.length,
            ")"
          ] }),
          /* @__PURE__ */ jsx5(
            "svg",
            {
              className: cn("w-3.5 h-3.5 transition-transform", expanded && "rotate-180"),
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              children: /* @__PURE__ */ jsx5("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" })
            }
          )
        ]
      }
    ),
    expanded && /* @__PURE__ */ jsx5("div", { className: "px-3 pb-2 space-y-0.5 max-h-32 overflow-y-auto", children: entries.map((entry, i) => {
      const isCurrent = i === currentIndex;
      const isFuture = i > currentIndex;
      return /* @__PURE__ */ jsxs5(
        "button",
        {
          onClick: () => onRestore(i),
          className: cn(
            "w-full text-left flex items-center gap-2 px-2 py-1 rounded text-xs transition-colors",
            isCurrent ? "bg-ac-highlight/20 text-ac-text" : isFuture ? "text-ac-muted/50 hover:text-ac-muted hover:bg-ac-accent/10" : "text-ac-muted hover:text-ac-text hover:bg-ac-accent/20"
          ),
          children: [
            /* @__PURE__ */ jsx5("span", { className: cn(
              "inline-block w-1.5 h-1.5 rounded-full shrink-0",
              isCurrent ? "bg-ac-highlight" : isFuture ? "bg-ac-muted/30" : "bg-ac-muted/50"
            ) }),
            /* @__PURE__ */ jsx5("span", { className: "flex-1 truncate", children: entry.label }),
            /* @__PURE__ */ jsx5("span", { className: "text-[10px] text-ac-muted/60 tabular-nums shrink-0", children: entry.slices.length })
          ]
        },
        `${i}-${entry.timestamp}`
      );
    }) })
  ] });
}

// src/ui/components/SampleChopperDialog.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
function SampleChopperDialog({
  open,
  onOpenChange,
  samples,
  sampleRate,
  sourceName,
  onConfirm,
  renderOutputConfig,
  editMode = false,
  initialSlices,
  initialLabels,
  onSlicesUpdated,
  onSave,
  initialTriggers,
  initialPlaybackConfig,
  onOpenSampleEditor
}) {
  var _a, _b, _c;
  const chopper = useSampleChopper({
    samples,
    sampleRate,
    open,
    editMode,
    initialSlices,
    labels: initialLabels
  });
  const { play, stop, isPlaying, playbackPosition, playbackPositionRef } = useAudioPreview({ sampleRate });
  const handlePlayAll = useCallback12(() => {
    if (!samples) return;
    if (isPlaying) {
      stop();
      return;
    }
    play(samples);
  }, [samples, isPlaying, play, stop]);
  const samplesRef = useRef8(samples);
  samplesRef.current = samples;
  const handleTriggerPlay = useCallback12(() => {
    if (samplesRef.current) play(samplesRef.current);
  }, [play]);
  const recorderRef = useRef8({
    triggerToSliceIndex: /* @__PURE__ */ new Map(),
    recordedSlices: []
  });
  const recorder = useTriggerRecorder({
    playbackPositionRef,
    isPlaying,
    onPlay: handleTriggerPlay,
    onStop: stop,
    onRetrigger: useCallback12((triggerId) => {
      const { triggerToSliceIndex, recordedSlices } = recorderRef.current;
      const sliceIndex = triggerToSliceIndex.get(triggerId);
      if (sliceIndex === void 0) return;
      const slice = recordedSlices[sliceIndex];
      if (!slice || !samplesRef.current) return;
      play(samplesRef.current, slice.startSample, slice.endSample);
    }, [play]),
    totalSamples: (_a = samples == null ? void 0 : samples.length) != null ? _a : 0,
    kitLabels: chopper.kitLabels
  });
  recorderRef.current = recorder;
  const mappings = useTriggerMappings({
    initialTriggers,
    initialPlaybackConfig,
    recordedMapping: recorder.triggerToSliceIndex
  });
  const midiLearnState = useMidiLearn({
    enabled: chopper.manualSlices.length > 0,
    onLearn: mappings.learnTrigger
  });
  const triggerPlayback = useTriggerPlayback({
    samples,
    sampleRate,
    slices: chopper.manualSlices,
    config: mappings.playbackConfig
  });
  const handlePlaySlice = useCallback12(
    (index) => {
      if (!samples || !chopper.currentSliceResult) return;
      const slice = chopper.currentSliceResult.slices[index];
      if (!slice) return;
      if (isPlaying && chopper.selectedSlice === index) {
        stop();
        return;
      }
      triggerPlayback.stopAll();
      chopper.setSelectedSlice(index);
      play(samples, slice.startSample, slice.endSample);
    },
    [samples, chopper.currentSliceResult, isPlaying, chopper.selectedSlice, play, stop, chopper.setSelectedSlice, triggerPlayback]
  );
  const handleTriggerPlaySlice = useCallback12(
    (index) => {
      chopper.setSelectedSlice(index);
      if (isPlaying) stop();
      triggerPlayback.playSlice(index);
    },
    [chopper.setSelectedSlice, isPlaying, stop, triggerPlayback]
  );
  const handleTriggerStopSlice = useCallback12(
    (index) => {
      triggerPlayback.stopSlice(index);
    },
    [triggerPlayback]
  );
  useTriggerPlaybackListeners({
    active: true,
    midiLearnActive: midiLearnState.isLearning,
    state: recorder.state,
    slices: chopper.manualSlices,
    effectiveMapping: mappings.effectiveMapping,
    onPlaySlice: handleTriggerPlaySlice,
    onStopSlice: handleTriggerStopSlice,
    playbackConfig: mappings.playbackConfig
  });
  useEffect7(() => {
    if ((recorder.state === "recording" || recorder.state === "complete") && recorder.recordedSlices.length > 0) {
      chopper.setManualSlices(recorder.recordedSlices);
    }
  }, [recorder.state, recorder.recordedSlices, chopper.setManualSlices]);
  const prevTriggerStateRef = useRef8(recorder.state);
  useEffect7(() => {
    if (prevTriggerStateRef.current === "recording" && recorder.state === "complete" && recorder.recordedSlices.length > 0) {
      chopper.pushHistory(recorder.recordedSlices, "Record triggers");
    }
    prevTriggerStateRef.current = recorder.state;
  }, [recorder.state, recorder.recordedSlices, chopper.pushHistory]);
  const handleTriggerReset = useCallback12(() => {
    recorder.reset();
    mappings.reset();
  }, [recorder, mappings]);
  const handleClose = useCallback12(() => {
    stop();
    onOpenChange(false);
  }, [onOpenChange, stop]);
  const handleConfirm = useCallback12(() => {
    if (!chopper.currentSliceResult || chopper.currentSliceResult.slices.length === 0 || !samples) return;
    const labels = chopper.kitLabels.split(",").map((s) => s.trim());
    const sliceDefinitions = chopper.selectedMethod === "manual" || chopper.useInitialSlices ? chopper.manualSlices : chopper.currentSliceResult.slices.map((slice, i) => {
      var _a2;
      return {
        label: (_a2 = labels[i % labels.length]) != null ? _a2 : `S${i + 1}`,
        startSample: slice.startSample,
        endSample: slice.endSample
      };
    });
    if (editMode && onSlicesUpdated) {
      onSlicesUpdated(sliceDefinitions);
      onOpenChange(false);
    } else {
      onConfirm({
        sliceDefinitions,
        sourceAudio: { samples, sampleRate }
      });
      onOpenChange(false);
    }
  }, [
    chopper.currentSliceResult,
    samples,
    chopper.kitLabels,
    chopper.selectedMethod,
    chopper.useInitialSlices,
    chopper.manualSlices,
    sampleRate,
    editMode,
    onConfirm,
    onSlicesUpdated,
    onOpenChange
  ]);
  const [isSaving, setIsSaving] = useState11(false);
  const handleSave = useCallback12(() => __async(null, null, function* () {
    if (!onSave || !samples || !chopper.currentSliceResult || chopper.currentSliceResult.slices.length === 0) return;
    setIsSaving(true);
    try {
      yield onSave({
        name: sourceName,
        slices: chopper.manualSlices,
        sourceAudio: { samples, sampleRate },
        triggers: mappings.triggerMappings.length > 0 ? mappings.triggerMappings : void 0,
        playbackConfig: mappings.playbackConfig.polyphony !== "poly" || mappings.playbackConfig.playbackMode !== "one-shot" || mappings.playbackConfig.muteGroups.length > 0 ? {
          polyphony: mappings.playbackConfig.polyphony,
          playbackMode: mappings.playbackConfig.playbackMode,
          muteGroups: mappings.playbackConfig.muteGroups
        } : void 0
      });
    } finally {
      setIsSaving(false);
    }
  }), [onSave, samples, chopper.currentSliceResult, chopper.manualSlices, sampleRate, sourceName, mappings.triggerMappings, mappings.playbackConfig]);
  const handleDialogKeyDown = useCallback12(
    (event) => {
      const target = event.target;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT") {
        return;
      }
      if (chopper.selectedMethod === "manual" && (recorder.state === "armed" || recorder.state === "recording")) {
        return;
      }
      if (event.key === "z" && (event.metaKey || event.ctrlKey) && !event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        chopper.handleUndo();
        return;
      }
      if (event.key === "z" && (event.metaKey || event.ctrlKey) && event.shiftKey || event.key === "y" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        event.stopPropagation();
        chopper.handleRedo();
        return;
      }
      if (event.key === "+" || event.key === "=") {
        event.preventDefault();
        event.stopPropagation();
        chopper.handleZoomIn();
        return;
      }
      if (event.key === "-" || event.key === "_") {
        event.preventDefault();
        event.stopPropagation();
        chopper.handleZoomOut();
        return;
      }
      if (event.key === "0") {
        event.preventDefault();
        event.stopPropagation();
        chopper.handleZoomReset();
        return;
      }
      if (event.key === "f" || event.key === "F" || event.key === "F11") {
        event.preventDefault();
        event.stopPropagation();
        chopper.setIsFullscreen((prev) => !prev);
        return;
      }
      if (event.key === "Escape" && chopper.isFullscreen) {
        event.preventDefault();
        event.stopPropagation();
        chopper.setIsFullscreen(false);
        return;
      }
      if (event.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        if (chopper.selectedSlice !== void 0) {
          handlePlaySlice(chopper.selectedSlice);
        } else {
          handlePlayAll();
        }
        return;
      }
      if ((event.key === "Delete" || event.key === "Backspace") && chopper.selectedMethod === "manual" && chopper.selectedSlice !== void 0) {
        event.preventDefault();
        event.stopPropagation();
        chopper.handleSliceDelete(chopper.selectedSlice);
        return;
      }
      if (event.key === "ArrowLeft" && chopper.currentSliceResult && chopper.currentSliceResult.slices.length > 0) {
        event.preventDefault();
        event.stopPropagation();
        const newIndex = chopper.selectedSlice !== void 0 ? Math.max(0, chopper.selectedSlice - 1) : chopper.currentSliceResult.slices.length - 1;
        chopper.setSelectedSlice(newIndex);
        return;
      }
      if (event.key === "ArrowRight" && chopper.currentSliceResult && chopper.currentSliceResult.slices.length > 0) {
        event.preventDefault();
        event.stopPropagation();
        const newIndex = chopper.selectedSlice !== void 0 ? Math.min(chopper.currentSliceResult.slices.length - 1, chopper.selectedSlice + 1) : 0;
        chopper.setSelectedSlice(newIndex);
        return;
      }
    },
    [chopper, recorder.state, handlePlaySlice, handlePlayAll]
  );
  const waveformHeight = chopper.isFullscreen ? 400 : 140;
  return /* @__PURE__ */ jsx6(Dialog.Root, { open, onOpenChange: handleClose, children: /* @__PURE__ */ jsxs6(Dialog.Portal, { children: [
    /* @__PURE__ */ jsx6(Dialog.Overlay, { className: "fixed inset-0 bg-black/50 z-50" }),
    /* @__PURE__ */ jsxs6(
      Dialog.Content,
      {
        className: cn(
          "fixed z-50 bg-ac-panel border border-ac-accent rounded-lg shadow-xl overflow-hidden flex flex-col",
          chopper.isFullscreen ? "inset-4" : "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl max-h-[90vh]"
        ),
        onKeyDown: handleDialogKeyDown,
        "data-slice-editor-open": "true",
        children: [
          /* @__PURE__ */ jsxs6("div", { className: "flex items-center justify-between p-4 border-b border-ac-accent shrink-0", children: [
            /* @__PURE__ */ jsxs6("div", { children: [
              /* @__PURE__ */ jsx6(Dialog.Title, { className: "text-lg font-bold text-ac-text", children: editMode ? "Edit Slices" : "Chop Sample" }),
              /* @__PURE__ */ jsxs6(Dialog.Description, { className: "text-sm text-ac-muted", children: [
                editMode ? `Edit slices for "${sourceName}"` : `Slice "${sourceName}" into individual regions`,
                chopper.durationMs > 0 && ` (${chopper.durationMs.toFixed(0)}ms)`
              ] })
            ] }),
            /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ jsx6(
                "button",
                {
                  onClick: () => chopper.setIsFullscreen((prev) => !prev),
                  className: "p-2 text-ac-muted hover:text-ac-text transition-colors",
                  title: chopper.isFullscreen ? "Exit fullscreen (F)" : "Fullscreen (F)",
                  children: chopper.isFullscreen ? /* @__PURE__ */ jsx6("svg", { className: "w-5 h-5", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }) : /* @__PURE__ */ jsx6("svg", { className: "w-5 h-5", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" }) })
                }
              ),
              /* @__PURE__ */ jsx6(Dialog.Close, { asChild: true, children: /* @__PURE__ */ jsx6(
                "button",
                {
                  className: "p-2 text-ac-muted hover:text-ac-text transition-colors",
                  "aria-label": "Close",
                  children: /* @__PURE__ */ jsx6("svg", { className: "w-5 h-5", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
                }
              ) })
            ] })
          ] }),
          /* @__PURE__ */ jsx6("div", { className: "flex-1 overflow-y-auto min-h-0 p-4", children: /* @__PURE__ */ jsxs6("div", { className: "space-y-4", children: [
            /* @__PURE__ */ jsxs6("div", { className: "space-y-2", children: [
              /* @__PURE__ */ jsxs6("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ jsx6("div", { className: "text-xs text-ac-muted uppercase tracking-wide", children: "Waveform & Slice Preview" }),
                /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-3", children: [
                  chopper.isManualMode && !chopper.stripSilenceActive && /* @__PURE__ */ jsx6("div", { className: "text-xs text-ac-muted", children: "Drag edges to adjust \u2022 Double-click to split \u2022 Delete to remove" }),
                  chopper.stripSilenceActive && /* @__PURE__ */ jsx6("div", { className: "text-xs text-ac-highlight", children: "Strip Silence Preview - Adjust threshold below" }),
                  chopper.isManualMode && !chopper.stripSilenceActive && /* @__PURE__ */ jsxs6(
                    "button",
                    {
                      onClick: () => chopper.setJoinedEdges((prev) => !prev),
                      className: cn(
                        "flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors",
                        chopper.joinedEdges ? "bg-ac-highlight/20 text-ac-highlight" : "bg-ac-bg text-ac-muted hover:text-ac-text"
                      ),
                      title: chopper.joinedEdges ? "Joined edges: ON" : "Joined edges: OFF",
                      children: [
                        /* @__PURE__ */ jsx6("svg", { className: "w-4 h-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" }) }),
                        chopper.joinedEdges ? "Joined" : "Split"
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx6("div", { className: "flex items-center gap-1 bg-ac-bg rounded px-2 py-1", children: /* @__PURE__ */ jsx6(
                    "button",
                    {
                      onClick: () => chopper.selectedSlice !== void 0 ? handlePlaySlice(chopper.selectedSlice) : handlePlayAll(),
                      className: cn(
                        "p-1 transition-colors",
                        isPlaying ? "text-red-400 hover:text-red-300" : "text-ac-muted hover:text-ac-text"
                      ),
                      title: isPlaying ? "Stop (Space)" : chopper.selectedSlice !== void 0 ? "Play selected slice (Space)" : "Play all (Space)",
                      children: isPlaying ? /* @__PURE__ */ jsxs6("svg", { className: "w-4 h-4", fill: "currentColor", viewBox: "0 0 24 24", children: [
                        /* @__PURE__ */ jsx6("rect", { x: "6", y: "5", width: "4", height: "14", rx: "1" }),
                        /* @__PURE__ */ jsx6("rect", { x: "14", y: "5", width: "4", height: "14", rx: "1" })
                      ] }) : /* @__PURE__ */ jsx6("svg", { className: "w-4 h-4", fill: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx6("path", { d: "M8 5v14l11-7z" }) })
                    }
                  ) }),
                  chopper.manualSlices.length > 0 && chopper.selectedSlice !== void 0 && /* @__PURE__ */ jsx6(
                    "button",
                    {
                      onClick: () => {
                        const idx = chopper.selectedSlice;
                        if (idx === void 0) return;
                        midiLearnState.learningSliceIndex === idx ? midiLearnState.cancelLearning() : midiLearnState.startLearning(idx);
                      },
                      className: cn(
                        "px-2 py-1 rounded text-xs font-medium transition-colors",
                        midiLearnState.learningSliceIndex === chopper.selectedSlice ? "bg-yellow-500/30 text-yellow-300 animate-pulse" : "bg-ac-bg text-ac-muted hover:text-ac-text"
                      ),
                      title: midiLearnState.isLearning ? "Cancel learn" : "Learn: assign a MIDI note or key to the selected slice",
                      children: midiLearnState.learningSliceIndex === chopper.selectedSlice ? "Learn..." : "Learn"
                    }
                  ),
                  (chopper.canUndo || chopper.canRedo) && /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-1 bg-ac-bg rounded px-2 py-1", children: [
                    /* @__PURE__ */ jsx6(
                      "button",
                      {
                        onClick: chopper.handleUndo,
                        disabled: !chopper.canUndo,
                        className: cn(
                          "p-1 text-ac-muted hover:text-ac-text transition-colors",
                          !chopper.canUndo && "opacity-30 cursor-not-allowed"
                        ),
                        title: "Undo (Ctrl+Z)",
                        children: /* @__PURE__ */ jsx6("svg", { className: "w-4 h-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M3 10h10a5 5 0 015 5v2M3 10l4-4m-4 4l4 4" }) })
                      }
                    ),
                    /* @__PURE__ */ jsx6(
                      "button",
                      {
                        onClick: chopper.handleRedo,
                        disabled: !chopper.canRedo,
                        className: cn(
                          "p-1 text-ac-muted hover:text-ac-text transition-colors",
                          !chopper.canRedo && "opacity-30 cursor-not-allowed"
                        ),
                        title: "Redo (Ctrl+Shift+Z)",
                        children: /* @__PURE__ */ jsx6("svg", { className: "w-4 h-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 10H11a5 5 0 00-5 5v2M21 10l-4-4m4 4l-4 4" }) })
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-1 bg-ac-bg rounded px-2 py-1", children: [
                    /* @__PURE__ */ jsx6(
                      "button",
                      {
                        onClick: chopper.handleZoomOut,
                        disabled: chopper.zoom <= MIN_ZOOM2,
                        className: cn(
                          "p-1 text-ac-muted hover:text-ac-text transition-colors",
                          chopper.zoom <= MIN_ZOOM2 && "opacity-30 cursor-not-allowed"
                        ),
                        title: "Zoom out (-)",
                        children: /* @__PURE__ */ jsx6("svg", { className: "w-4 h-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7" }) })
                      }
                    ),
                    /* @__PURE__ */ jsx6(
                      "button",
                      {
                        onClick: chopper.handleZoomReset,
                        className: "px-2 text-xs text-ac-muted hover:text-ac-text transition-colors min-w-[3rem]",
                        title: "Reset zoom (0)",
                        children: chopper.zoom > 1 ? `${chopper.zoom.toFixed(1)}\xD7` : "Fit"
                      }
                    ),
                    /* @__PURE__ */ jsx6(
                      "button",
                      {
                        onClick: chopper.handleZoomIn,
                        disabled: chopper.zoom >= MAX_ZOOM2,
                        className: cn(
                          "p-1 text-ac-muted hover:text-ac-text transition-colors",
                          chopper.zoom >= MAX_ZOOM2 && "opacity-30 cursor-not-allowed"
                        ),
                        title: "Zoom in (+)",
                        children: /* @__PURE__ */ jsx6("svg", { className: "w-4 h-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ jsx6("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" }) })
                      }
                    )
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ jsx6(
                WaveformEditor,
                {
                  samples,
                  sampleRate,
                  sliceMarkers: chopper.sliceMarkers,
                  selectedSlice: chopper.selectedSlice,
                  onSliceClick: chopper.setSelectedSlice,
                  height: waveformHeight,
                  editable: chopper.isManualMode && !chopper.stripSilenceActive,
                  onSliceChange: chopper.isManualMode && !chopper.stripSilenceActive ? chopper.handleSliceChange : void 0,
                  onSlicesChange: chopper.isManualMode && !chopper.stripSilenceActive ? chopper.handleSlicesChange : void 0,
                  onSliceAdd: chopper.isManualMode && !chopper.stripSilenceActive ? chopper.handleSliceAdd : void 0,
                  onSliceDelete: chopper.isManualMode && !chopper.stripSilenceActive ? chopper.handleSliceDelete : void 0,
                  zoom: chopper.zoom,
                  onZoomChange: chopper.setZoom,
                  joinedEdges: chopper.isManualMode && chopper.joinedEdges && !chopper.stripSilenceActive,
                  playbackPosition
                }
              ),
              chopper.currentSliceResult && /* @__PURE__ */ jsxs6("div", { className: "flex items-center justify-between text-xs text-ac-muted", children: [
                /* @__PURE__ */ jsxs6("span", { children: [
                  chopper.currentSliceResult.slices.length,
                  " slice",
                  chopper.currentSliceResult.slices.length !== 1 ? "s" : "",
                  chopper.selectedSlice !== void 0 && chopper.currentSliceResult.slices[chopper.selectedSlice] && /* @__PURE__ */ jsxs6("span", { className: "ml-2 text-ac-text", children: [
                    "\u2022 Selected: ",
                    (_b = chopper.currentSliceResult.slices[chopper.selectedSlice]) == null ? void 0 : _b.durationMs.toFixed(0),
                    "ms"
                  ] })
                ] }),
                !chopper.isManualMode && chopper.autoSliceResult && chopper.autoSliceResult.slices.length > 0 && /* @__PURE__ */ jsx6(
                  "button",
                  {
                    onClick: chopper.handleSwitchToManual,
                    className: "text-ac-highlight hover:underline",
                    children: "Edit manually"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ jsx6(
              SliceMethodPanel,
              {
                selectedMethod: chopper.selectedMethod,
                onMethodChange: chopper.handleMethodChange,
                transientThreshold: chopper.transientThreshold,
                onTransientThresholdChange: chopper.setTransientThreshold,
                transientMinGap: chopper.transientMinGap,
                onTransientMinGapChange: chopper.setTransientMinGap,
                transientPrePad: chopper.transientPrePad,
                onTransientPrePadChange: chopper.setTransientPrePad,
                fixedCount: chopper.fixedCount,
                onFixedCountChange: chopper.setFixedCount,
                stripSilenceThreshold: chopper.stripSilenceThreshold,
                onStripSilenceThresholdChange: chopper.setStripSilenceThreshold,
                stripSilenceActive: chopper.stripSilenceActive,
                strippedPreview: chopper.strippedPreview,
                originalSliceBoundaries: chopper.originalSliceBoundaries,
                onApplyStripSilence: chopper.handleApplyStripSilence,
                onCancelStripSilence: chopper.handleCancelStripSilence,
                onActivateStripSilence: chopper.activateStripSilence,
                manualSlices: chopper.manualSlices,
                triggerProps: {
                  state: recorder.state,
                  midiAvailable: recorder.midiAvailable,
                  triggerCount: recorder.triggerCount,
                  onArm: recorder.arm,
                  onStop: recorder.stopRecording,
                  onReset: handleTriggerReset,
                  playbackConfig: mappings.playbackConfig,
                  onPolyphonyChange: mappings.setPolyphony,
                  onPlaybackModeChange: mappings.setPlaybackMode,
                  onMuteGroupChange: mappings.setMuteGroup,
                  slices: chopper.manualSlices,
                  latencyMs: triggerPlayback.latencyMs
                },
                onAutoMap: (autoMappings) => {
                  for (const { sliceIndex, triggerId } of autoMappings) {
                    mappings.learnTrigger(sliceIndex, triggerId);
                  }
                },
                onApplyAutoSlice: chopper.handleApplyAutoSlice,
                autoSliceCount: (_c = chopper.autoSliceResult) == null ? void 0 : _c.slices.length
              }
            ),
            chopper.sliceMarkers.length > 0 && /* @__PURE__ */ jsx6(
              SliceList,
              {
                slices: chopper.manualSlices,
                selectedSlice: chopper.selectedSlice,
                sampleRate,
                isPlaying,
                onSliceSelect: chopper.setSelectedSlice,
                onSlicePlay: handlePlaySlice,
                onSliceDelete: chopper.handleSliceDelete,
                editable: chopper.isManualMode,
                triggerAssignments: mappings.triggerMappings,
                learningSliceIndex: midiLearnState.learningSliceIndex,
                onStartLearn: midiLearnState.startLearning,
                onCancelLearn: midiLearnState.cancelLearning,
                onClearTrigger: mappings.clearLearnedTrigger
              }
            ),
            chopper.historyEntries.length > 1 && /* @__PURE__ */ jsx6(
              ChangeHistory,
              {
                entries: chopper.historyEntries,
                currentIndex: chopper.historyIndex,
                onRestore: chopper.handleRestoreHistory
              }
            ),
            mappings.triggerMappings.length > 0 && /* @__PURE__ */ jsx6(
              PlaybackControls,
              {
                playbackConfig: mappings.playbackConfig,
                onPolyphonyChange: mappings.setPolyphony,
                onPlaybackModeChange: mappings.setPlaybackMode,
                onMuteGroupChange: mappings.setMuteGroup,
                slices: chopper.manualSlices,
                latencyMs: triggerPlayback.latencyMs
              }
            ),
            chopper.sliceError && /* @__PURE__ */ jsx6("div", { className: "text-sm text-red-400 bg-red-900/20 rounded p-2", children: chopper.sliceError }),
            renderOutputConfig && renderOutputConfig({
              sliceDefinitions: chopper.manualSlices,
              currentSliceResult: chopper.currentSliceResult,
              labels: chopper.kitLabels,
              onLabelsChange: chopper.setKitLabels
            })
          ] }) }),
          /* @__PURE__ */ jsxs6("div", { className: "flex justify-between items-center gap-2 p-4 border-t border-ac-accent shrink-0 bg-ac-panel", children: [
            /* @__PURE__ */ jsx6("div", { className: "text-xs text-ac-muted", children: "Space play \u2022 \u2190\u2192 navigate \u2022 +/- zoom \u2022 F fullscreen \u2022 Ctrl+Z undo" }),
            /* @__PURE__ */ jsxs6("div", { className: "flex gap-2", children: [
              onSave && /* @__PURE__ */ jsx6(
                "button",
                {
                  onClick: handleSave,
                  disabled: isSaving || !chopper.currentSliceResult || chopper.currentSliceResult.slices.length === 0,
                  className: cn(
                    "ac-btn ac-btn-ghost",
                    (isSaving || !chopper.currentSliceResult || chopper.currentSliceResult.slices.length === 0) && "opacity-50 cursor-not-allowed"
                  ),
                  children: isSaving ? "Saving..." : "Save"
                }
              ),
              !onSave && renderOutputConfig && /* @__PURE__ */ jsx6(
                "button",
                {
                  onClick: handleConfirm,
                  disabled: !chopper.currentSliceResult || chopper.currentSliceResult.slices.length === 0,
                  className: cn(
                    "ac-btn ac-btn-primary",
                    (!chopper.currentSliceResult || chopper.currentSliceResult.slices.length === 0) && "opacity-50 cursor-not-allowed"
                  ),
                  children: "Create Drum Kit"
                }
              ),
              onOpenSampleEditor && /* @__PURE__ */ jsx6(
                "button",
                {
                  onClick: onOpenSampleEditor,
                  className: "ac-btn ac-btn-ghost",
                  "data-testid": "chopper-edit-sample-button",
                  children: "Edit Sample"
                }
              ),
              /* @__PURE__ */ jsx6("button", { onClick: handleClose, className: "ac-btn ac-btn-ghost", children: "Cancel" })
            ] })
          ] })
        ]
      }
    )
  ] }) });
}
export {
  MAX_ZOOM2 as MAX_ZOOM,
  MIN_ZOOM2 as MIN_ZOOM,
  SampleChopperDialog,
  SliceList,
  SliceMethodPanel,
  TriggerMethodContent,
  WaveformEditor,
  cn,
  useAudioPreview,
  useSampleChopper,
  useTriggerInput,
  useTriggerMappings,
  useTriggerPlayback,
  useTriggerPlaybackListeners,
  useTriggerRecorder
};
//# sourceMappingURL=index.js.map